<template>
  <!-- eslint-disable -->
  <v-container fluid class="current-overview-map-vue shared-maps deliverability-map" id="current-overview-map-vue">
    <v-slide-y-transition mode="out-in">
      <div style="height: 100%">
        <v-menu bottom right offset-y class="findthis" style="position: fixed; top: 0; right: 0; z-index: 9;" nudge-bottom="8" nudge-right="10">
          <template v-slot:activator="{ on }">
            <v-btn v-on="on" light icon style="position: absolute; z-index: 32; top: -45px; right: 10px;">
              <v-icon>more_vert</v-icon>
            </v-btn>
          </template>
          <v-list style="padding: 10px;">
            <v-list-item>
              <v-btn text small class="add-user-btn" @click="loadMapData(true)">
                <v-icon>refresh</v-icon> Refresh
              </v-btn>
            </v-list-item>
            <v-list-item>
              <v-switch class="map-toggle" label="Map" :disabled="!showGrid" v-model="showMap"></v-switch>
            </v-list-item>
            <v-list-item>
              <v-switch class="data-toggle" label="Data" v-model="showGrid"></v-switch>
            </v-list-item>
          </v-list>
        </v-menu>
        <div id="map" class="map" style="height:100%;z-index:0;"></div>
    <!-- FILE TREE -->
        <v-navigation-drawer style="padding-top: 56px; overflow-y: auto;" :width="overlayNavWidth" fixed :mini-variant="false" :clipped="true" v-model="showOverlaySelect" :touchless="true" :mobile-break-point="0"> 
          <div v-if="showWeatherOverlaySelect">
            <h3 style="padding: 15px; text-align: center;">Weather Data</h3>
            <h4 style="text-align: center; padding-bottom: 25px;" v-if="overlayTreeData.length == 0 && !loadingFiles">No Data To Display</h4>
            <v-progress-circular style="    width: 100%; margin-bottom: 25px;" :size="55" :width="5" indeterminate color="primary" v-if="loadingFiles" />
            <v-expansion-panels style="overflow: hidden;">
              <v-expansion-panel v-for="region in overlayTreeData" :key="region.id">
                <v-expansion-panel-header>
                  <strong>{{region.name}}</strong>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <v-card>
                    <v-expansion-panels>
                      <v-expansion-panel v-for="event in region.children" :key="event.id">
                        <v-expansion-panel-header expand-icon="arrow_drop_down">
                          <div style="padding-left: 10px; font-weight: 500;">{{event.name}}</div>
                        </v-expansion-panel-header>
                        <v-expansion-panel-content>
                          <v-card>
                            <div v-for="enumType in event.children" :key="enumType.id">
                              <div class="overlay-list-item" small flat :disabled="enumType.Selected" :style="{'background-color': enumType.Selected? '#000': '', 'color': enumType.Selected? '#fff': ''}" style="padding: 4px 0px 4px 40px"  @click="selectOverlay(enumType, region.key)">{{enumType.name}} </div>
                            </div>
                          </v-card>
                        </v-expansion-panel-content>
                      </v-expansion-panel>
                    </v-expansion-panels>
                  </v-card>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </div>
          <div v-if="showHurricaneOverlaySelect">
            <h3 style="padding: 15px; text-align: center;">Hurricane Data</h3>
            <h4 style="text-align: center; padding-bottom: 25px;" v-if="hurricaneTreeData.length == 0 && !loadingHurricaneData">No Data To Display</h4>
            <v-progress-circular style="width: 100%; margin-bottom: 25px;" :size="55" :width="5" indeterminate color="primary" v-if="loadingHurricaneData" />
            <v-expansion-panels style="overflow: hidden;">
              <v-expansion-panel v-for="region in hurricaneTreeData" :key="region.id">
                <v-expansion-panel-header>
                  <strong>{{region.name}}</strong>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <v-card>
                    <div v-for="storm in region.children" :key="storm.id">
                      <div class="overlay-list-item" small text :disabled="storm.Selected" :style="getStormListStyle(storm)" style="padding: 4px 0px 4px 40px; font-weight: 500;"  @click="selectStorm(storm)">
                        <span v-if="storm.stormName">{{storm.stormName}} ({{storm.atcfId}})</span>
                        <span v-else>{{storm.atcfId}}</span>
                      </div>
                    </div>
                  </v-card>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
            <div @click="toggleHurricaneOverviewLayer()" style="padding-left: 25px;">
              <v-checkbox label="Show Hurricane Overview" :value="map.hasLayer(hurricaneOverviewLayer)"/>
            </div>
          </div>
          <div style="text-align: center; padding-top: 15px;">
            <v-btn depressed v-if="showOverlaySelect" color="grey" @click="showOverlaySelect = false; showHurricaneOverlaySelect = false; showWeatherOverlaySelect = false;">
              <v-icon dark>close</v-icon> Close
            </v-btn>
          </div>
        </v-navigation-drawer>
    <!-- END FILE TREE -->
        <div class="grid-container" id="grid-container" :style="{width: showOverlaySelect? 'calc(100% - ' + overlayNavWidth + 'px)':'100%', 'max-height': getTableHeightPercent(), 'height': !this.showMap ? '100%' : 'unset'}">
          <div class="overview-tabs">
            <v-layout wrap style="flex-wrap: nowrap">
              <v-tabs id="overview-tabs" active-class="color-black" v-model="currentTab" color="#fcfcf7" style="background-color: #fcfcf7; max-width: fit-content;" :touchless="true" slider-color="black">
                <v-tab v-for="tab in gridTabs" :key="tab.key" ripple :class="tab.key">{{tab.label}}</v-tab>
              </v-tabs>
              <v-select :hide-details="true" style="padding: 11px 25px 0 25px; max-width: 200px;" label="Timezone" :items="timeZones" item-text="Label" item-value="Code" v-model="selectedTimezone"></v-select>
            </v-layout>
<!-- ALERTS -->
            <div v-show="currentTab == 0">
              <v-layout id="filter-selectors" class="alert_selectors" wrap>
                <v-select style="padding: 15px 15px 0 15px;" class="day_selectors"  item-value="Key" label="Select Day" :items="alertDaySelectData"  v-model="selectedDay">
                  <template slot="selection" slot-scope="{ item }">
                    {{item.Label}}: ({{filteredTotalSummary[item.Key].total}}) 
                  </template>
                  <template v-slot:item="{ item }">
                    {{item.Label}}: ({{filteredTotalSummary[item.Key].total}}) 
                  </template>
                </v-select> 
                <v-select :menu-props="{contentClass:'select-box'}" style="padding: 15px;" v-if="alertDayData[selectedDay]" :items="deliverabilityAlertTypesToggleArray" :hide-details="true" multiple prepend-icon="report_problem" label="Alert Types" single-line>
                  <template slot="selection" slot-scope="{ item, index }">
                    <div v-if="index === 0">
                      <span style="color: black;opacity: 0.53;line-height: 32px;">Alert Types</span>
                    </div>
                  </template>
                  <template v-slot:item="{ item }">
                    <div class="select-checkbox-cover-deliverability" @click="deliverabilityAlertTypesToggle[item.key].toggle = !deliverabilityAlertTypesToggle[item.key].toggle; recreateDayGeoJson(); setFilteredTotalSummary();"></div>
                    <v-checkbox style="pointer-events: none;" v-model="deliverabilityAlertTypesToggle[item.key].toggle" 
                      :label="item.label+': '+  (filteredTotalSummary[selectedDay].deliverabilityAlertTypes[item.key]? filteredTotalSummary[selectedDay].deliverabilityAlertTypes[item.key]:0)"
                    ></v-checkbox>
                  </template>
                </v-select>              
                <v-select :menu-props="{contentClass:'select-box'}" style="padding: 15px;" v-if="alertDayData[selectedDay]" :items="riskCategoriesToggleArray" :hide-details="true" multiple prepend-icon="label" label="Risk" single-line>
                  <template slot="selection" slot-scope="{ item, index }">
                    <div v-if="index === 0">
                      <span style="color: black;opacity: 0.53;line-height: 32px;">Risk</span>
                    </div>
                  </template>
                  <template v-slot:item="{ item }">
                    <div class="select-checkbox-cover-deliverability" @click="riskCategoriesToggle[item].toggle = !riskCategoriesToggle[item].toggle"></div>
                    <v-checkbox :color="riskCategoriesToggle[item].stroke" style="pointer-events: none;" v-model="riskCategoriesToggle[item].toggle" 
                      :label="item+': '+ (filteredTotalSummary[selectedDay].riskCategories[item]? filteredTotalSummary[selectedDay].riskCategories[item]:0)"
                    ></v-checkbox>
                  </template>
                </v-select>
                <v-text-field v-if="alertDayData[selectedDay] && alertDayData[selectedDay].TableData.length > 0" v-model="alertsTableSearch"  style="padding: 15px; 15px 0 15px" prepend-icon="search" label="Search Table Data" single-line hide-details></v-text-field>    
              </v-layout>
              <div v-if="alertDayData[selectedDay]">
                <div>
                  <v-data-table :mobile-breakpoint="0" ref="alertsDataTable" class="no-wrap-th" disable-pagination hide-default-footer :search="alertsTableSearch" :items="alertDayData[selectedDay].TableData"  item-key="alertid" :headers="alertSummaryHeaders" :sort-by.sync="sortBy" :sort-desc.sync="descending" :loading="loadingAlerts" >
                    <template v-slot:item="{ item, expand, isExpanded }" item-key="HashKey" >
                      <tr oncontextmenu="return false;"   class="data-td no-text-select location-data-row" 
                        @contextmenu="expand(!isExpanded); return false" 
                        @dblclick="expand(!isExpanded);"
                        @mouseenter="setSelectedAlertMarker(item.alertid)"
                        @mouseleave="removeSelectedAlertMarker()"
                        :id="'overview-data-' + item.alertid"
                        v-if="deliverabilityAlertTypesToggle[item.type].toggle === true && riskCategoriesToggle[item.riskcategory].toggle === true"
                        :style="'background-color: ' + riskCategoriesToggle[item.riskcategory].backgroundColor"
                      >
                        <td style="white-space: nowrap;">
                          {{ item.riskcategory }}: {{ item.normalizedrisk }} <!--{{item.alertid}}-->
                        </td>
                        <td>
                          {{deliverabilityAlertTypesToggle[item.type].label}}
                        </td>
                        <td>
                          {{formatTime(item.effectivedate)}}
                        </td>
                        <td>
                          {{formatTime(item.expiresdate)}}
                        </td>
                        <td>
                          {{item.summary}}
                        </td>
                      </tr>
                    </template>
                    <template v-slot:expanded-item="{ headers, item }">
                      <td :colspan="headers.length" style="padding: 0;">
                        <v-card text style="padding: 15px;">
                          <v-btn depressed small style="margin: 0 0 15px 0;" @click="setSelectedAlertMarker(item.alertid); zoomToFit(selectedAlertMarker);">Show On Map</v-btn>                      
                          <div>
                            <strong>Risk:</strong> {{ item.riskcategory }}: {{ item.normalizedrisk }}<br/>
                            <strong>Alert Type:</strong> {{deliverabilityAlertTypesToggle[item.type].label}}<br/>
                            <strong>Effective Date:</strong> {{formatTime(item.effectivedate)}}<br/>
                            <strong>Expiration Date:</strong> {{formatTime(item.expiresdate)}}<br/>
                            <strong>Summary:</strong> {{item.summary}}<br/>
                          </div>
                          <!-- Carrier Type -->
                          <div v-if="item.type === 'Carrier'" >
                            <strong>Carrier:</strong> {{item.carrier.carrier}}
                          </div>
                          <!-- Nws Type -->
                          <div v-if="item.type === 'Nws'" >
                            <strong>Event:</strong> {{item.event}}<br/>
                            <strong>Link:</strong> <a :href="item.link" target="_blank">{{item.link}}</a><br/>
                            <strong>Publish Date:</strong> {{formatTime(item.publisheddate)}}<br/>
                            <strong>Updated Date:</strong> {{formatTime(item.updateddate)}}<br/>
                            <strong>Area Description:</strong> {{item.areadesc}}<br/>
                            <strong>Severity:</strong> {{item.nws.severity}}<br/>
                            <strong>Urgency:</strong> {{item.nws.urgency}}<br/>
                            <strong>Certainty:</strong> {{item.nws.certainty}}<br/>
                            <strong>Category:</strong> {{item.nws.category}}<br/>
                            <strong>Phenomena:</strong> {{item.nws.phenomena}}<br/>
                            <strong>Significance:</strong> {{item.nws.significance}}<br/>
                            <strong>VTec:</strong> {{item.nws.vtec}}<br/>
                            <strong>Geo Code List:</strong> {{item.geocodelist}}
                          </div>
                          <!-- NwsExtended Type -->
                          <div v-if="item.type === 'NwsExtended'" >
                            <strong>Event:</strong> {{item.event}}<br/>
                            <strong>Publish Date:</strong> {{formatTime(item.publisheddate)}}<br/>
                            <strong>Category:</strong> {{item.nwsextended.category}}<br/>
                          </div>
                          <!-- All Types -->
                          <div>
                            <div><strong>Zip Code List:</strong><v-icon small @click="copyZipCodeListToClipboard(item.zipcodelist)">file_copy</v-icon> </div>
                            <span v-for="(zip, index) in item.zipcodelist" :key="zip">{{zip}}<span v-if="index != item.zipcodelist.length - 1">, </span></span>
                          </div>
                        </v-card>
                      </td>
                    </template>
                  </v-data-table>
                </div>
              </div>
            </div>
<!-- END ALERTS -->
<!-- OVERLAYS -->
            <div v-show="currentTab == 1">
              <div style="padding: 10px 5px; position: relative; overflow: auto;">
                <div style="text-align: center; height: 200px;" v-if="!currentOverlay">
                  <h3>
                    Select Weather Overlay from list
                    <v-icon @click="showOverlaySelect = true; showWeatherOverlaySelect = true; stopOverlay();">filter_drama</v-icon>
                  </h3>
                </div>
            <!-- OVERLAY SLIDER -->
                <div v-if="currentOverlay">
                  <v-layout>
                    <v-flex>
                      <v-layout>
                        <div style="padding: 0 15px;">
                          <strong style="font-size: medium;">{{currentOverlay.label}}</strong>
                        </div>
                        <v-btn small style="margin: 0; position: relative; bottom: 3px; right: 7px;" text icon @click="selectOverlay()"><v-icon>close</v-icon></v-btn>
                      </v-layout>
                    </v-flex>
                    <v-flex style="text-align: right; padding-right: 15px;">
                      <v-icon v-show="!play" :style="{'color': play? '#1976d2' : '#707070'}" @click="playSelectedOverlay(sliderNum)">play_arrow</v-icon>
                      <v-icon v-show="play" :style="{'color': !play? '#1976d2' : '#707070'}" @click="stopOverlay()">pause</v-icon>
                      <span style="font-weight: 900; position: relative; top: 3px; font-size: 17px; color: #707070;" @click="overlayPlaySpeedIdx = (overlayPlaySpeedIdx + 1) % overlayPlaySpeeds.length">{{overlayPlaySpeeds[overlayPlaySpeedIdx].label}}</span>
                      <v-icon :style="{'color': overlayRepeat? '#1976d2' : '#707070'}" @click="overlayRepeat = !overlayRepeat">replay</v-icon>
                    </v-flex>
                  </v-layout>
                  <div style="padding: 0 15px;">
                    <b>Forecast Start:</b> {{getCurrentShownTime(currentOverlay.fileForecastTimeUtc, 0)}} &emsp; 
                    <span v-if="getCurrentFileDelayDuration() > 0">
                      <b>Time Start:</b> {{getCurrentShownTime(currentOverlay.fileForecastTimeUtc, sliderNum - getCurrentFileDelayDuration())}} &emsp; 
                      <b>Time End:</b> {{getCurrentShownTime(currentOverlay.fileForecastTimeUtc, sliderNum)}}
                    </span>
                    <span v-else>
                      <b>Event Time:</b> {{getCurrentShownTime(currentOverlay.fileForecastTimeUtc, sliderNum)}}
                    </span>
                  </div>
                  <div style="width: 100%; overflow-x: auto;">
                    <div v-if="currentOverlay.ticks" style="width: 100%; padding: 30px 25px 30px 25px;">
                      <div  v-if="currentOverlay.ticks.length > 0" style="position: relative;">
                        <vue-slider :tooltip-formatter="val => sliderTooltipFormat(val)" @change="sliderChange($event, currentOverlay); stopOverlay()" :tooltip="'always'" :tooltip-placement="'top'" :duration="0" :min="0" :max="currentOverlay.ticks[currentOverlay.ticks.length - 1]" :adsorb="true" :hideLabel="true" v-model="sliderNum" :marks="currentOverlay.ticks" :included="true"></vue-slider>
                        <div class="slider-day-ticks" :style="{'left': day.offset + '%'}" v-for="day in getCurrentOverlayDaySpacerData(currentOverlay.fileForecastTimeUtc, currentOverlay.ticks[currentOverlay.ticks.length - 1])" :key="day.day">   
                          <div class="slider-day-tick"></div>
                          <div class="slider-day-label">{{day.label}}</div>   
                        </div>
                        <div class="slider-event-duration">
                          <div class="event-duration" :style="getDurationOffset()"></div>
                        </div>
                      </div>
                    </div>
                  </div>              
                  <v-layout>
                    <v-flex xs6 hidden-sm-and-up style="text-align: center;">
                      <v-btn text icon color="grey darken-1" @click="playNextOverlayFrame(-1)">
                        <v-icon dark>skip_previous</v-icon>
                      </v-btn>
                    </v-flex>
                    <v-flex xs6 hidden-sm-and-up style="text-align: center;">
                      <v-btn text icon color="grey darken-1" @click="playNextOverlayFrame(1)">
                        <v-icon dark>skip_next</v-icon>
                      </v-btn>
                    </v-flex>
                  </v-layout>
              <!-- END OVERLAY SLIDER -->
              <!-- OVERLAY LEGEND -->
                  <div v-if="currentOverlay.Legend" class="overlay-legend-table" style="margin: 0 15px;">
                    <div v-for="legend in currentOverlay.Legend" :key="legend.Label" style="padding: 2px 15px 6px 7px;" class="overlay-legend-row">
                      <v-layout row style="padding: 0 15px;">
                        <v-checkbox hide-details v-model="legend.showLayer" style="position: relative; max-width: 40px; margin: 0;" @change="toggleLegendLayer($event, stripClass(legend.layerId))"></v-checkbox>
                        <div style="position: relative; width: 75px; top: 8px; height: 15px;">
                          <div style="height: 15px; background-color: transparent;" :style="{'border': '2px solid ' + legend.Stroke}"></div>
                          <div style="position: absolute; height: 15px; width: 100%; top: 0;" :style="{'opacity': legend.Opacity, 'background-color': legend.Fill}"></div>
                        </div>
                        <div style="padding: 0 20px; position: relative; top: 5px;">{{legend.Label}}</div>
                        <!--<div v-if="legend.ZipCodeList['idx_' + getSliderNumIndex(sliderNum)]">
                          <div v-if="legend.ZipCodeList['idx_' + getSliderNumIndex(sliderNum)].length > 0" style="padding-left: 40px">
                            <span style="position: relative; bottom: 3px;">Zip</span> 
                            <v-icon small class="btn-hover" style="padding: 5px;" @click="copyZipCodeListToClipboard(legend.ZipCodeList['idx_' + getSliderNumIndex(sliderNum)])">file_copy</v-icon>
                          </div>
                        </div>-->
                        <div style="padding: 0 20px; position: relative; top: 5px;" v-if="false && legend.ValueLabelList['idx_' + getSliderNumIndex(sliderNum)]">{{legend.ValueLabelList['idx_' + getSliderNumIndex(sliderNum)]}}</div>
                      </v-layout>
                    </div>
                  </div>
              <!-- END OVERLAY LEGEND -->
                </div>
              </div>
            </div>
            <div v-show="currentTab == 2">
              <div style="padding: 10px 5px; position: relative; overflow: auto;">
                <div style="text-align: center; height: 200px;" v-if="!selectedStorm">
                  <h3 style="text-align: center;">
                    <v-layout justify-center>
                      <div>Select Hurricane Overlay from list</div>
                      <div class="overview-toggle" @click="showOverlaySelect = true; showHurricaneOverlaySelect = true; stopOverlay();">
                        <svg style="width: 20px; position: relative; top: 4px; padding-left: 5px;" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512">
                          <path d="M176 96l24.5-74.8C204 10.6 195.9 0 185.1 0c-.7 0-1.3 0-2 .1C80 12.4 0 101.6 0 208c0 114.9 93.1 208 208 208l-24.5 74.8c-3.5 10.6 4.6 21.2 15.4 21.2.7 0 1.3 0 2-.1C304 499.6 384 410.4 384 304c0-114.9-93.1-208-208-208zm46.3 379.2l16.1-49.3 13.7-42H208c-97 0-176-79-176-176 0-81.1 54.2-150.7 129.7-171.2L145.6 86l-13.7 42H176c97 0 176 79 176 176 0 81.1-54.2 150.7-129.7 171.2zM192 184c-39.8 0-72 32.2-72 72s32.2 72 72 72 72-32.2 72-72-32.2-72-72-72zm0 112c-22.1 0-40-17.9-40-40s17.9-40 40-40 40 17.9 40 40-17.9 40-40 40z"></path></svg>
                      </div>
                    </v-layout>
                  </h3> 
                </div>
            <!-- OVERLAY SLIDER -->
                <div v-if="selectedStorm" style="padding: 5px 15px;">
                  <v-layout>
                    <div style="border-bottom: 1px solid grey; padding: 0 0 5px 5px; margin-bottom: 10px; width: fit-content;" @click="toggleHurricaneShowDetail(selectedStorm)">
                      <strong style="font-size: medium;">
                        <span v-if="selectedStorm.stormName">{{selectedStorm.stormName}} ({{selectedStorm.atcfId}})</span>
                        <span v-else>{{selectedStorm.atcfId}}</span>
                      </strong>
                      <v-icon style="position: relative; top: 3px;">{{!selectedStorm.showDetail ? 'arrow_drop_down' : 'arrow_drop_up'}}</v-icon>
                    </div>
                    <v-btn style="margin: 0;" text small icon @click="selectStorm()"><v-icon>close</v-icon></v-btn>
                  </v-layout>
                  <div v-if="selectedStorm.showDetail" style="padding-bottom: 15px;">
                    <table class="hurricaneSummaryTable">
                      <tr v-if="selectedStorm.currentForecast.properties.HurricaneCategory"><td class="sum-title">Hurricane Category</td><td>{{selectedStorm.currentForecast.properties.HurricaneCategory}}</td></tr>
                      <tr v-if="selectedStorm.currentForecast.properties.SaffirSimpsonCategory"><td class="sum-title">Saffir Simpson Category</td><td>{{selectedStorm.currentForecast.properties.SaffirSimpsonCategory}}</td></tr>
                      <tr v-if="selectedStorm.currentForecast.properties.StormType"><td class="sum-title">Storm Type</td><td>{{selectedStorm.currentForecast.properties.StormType}}</td></tr>
                      <tr v-if="selectedStorm.region"><td class="sum-title">Region</td><td>{{selectedStorm.region}}</td></tr>
                      <tr v-if="selectedStorm.currentForecast.properties.MovementDirectionDegrees"><td class="sum-title">Movement Direction</td><td>{{selectedStorm.currentForecast.properties.MovementDirectionDegrees}}&deg;</td></tr>
                      <tr v-if="selectedStorm.currentForecast.properties.MovementDirectionMph"><td class="sum-title">Movement Speed</td><td>{{selectedStorm.currentForecast.properties.MovementDirectionMph}}<sub>mph</sub></td></tr>
                      <tr v-if="selectedStorm.currentForecast.properties.PressureMillibars"><td class="sum-title">Pressure</td><td>{{selectedStorm.currentForecast.properties.PressureMillibars}}<sub>mb</sub></td></tr>
                      <tr v-if="selectedStorm.currentForecast.properties.WindSpeedMph"><td class="sum-title">Wind Speed</td><td>{{selectedStorm.currentForecast.properties.WindSpeedMph}}<sub>mph</sub></td></tr>
                      <tr v-if="selectedStorm.alertDateTimeUtc"><td class="sum-title">Alert Date</td><td>{{formatTime(selectedStorm.alertDateTimeUtc)}}</td></tr>
                      <tr v-if="selectedStorm.forecastTitle"><td class="sum-title">Forecast Title</td><td>{{selectedStorm.forecastTitle}}</td></tr>
                      <tr v-if="selectedStorm.forecastText"><td class="sum-title">Forecast Text</td><td>{{selectedStorm.forecastText}}</td></tr>
                      <tr v-if="selectedStorm.advisoryNumber"><td class="sum-title">Advisory Number</td><td>{{selectedStorm.advisoryNumber}}</td></tr>
                      <tr v-if="selectedStorm.wallet"><td class="sum-title">Wallet</td><td>{{selectedStorm.wallet}}</td></tr>
                    </table>
                  </div>
                  <div v-if="selectedStorm.LoadingData" style="position: relative; height: 150px;">
                    <v-progress-circular style="position: absolute; left: 50%; transform: translate(50%, 50%);" :size="55" :width="5" indeterminate color="primary"/>
                  </div>
                  <div v-else>
                    <div v-if="selectedStorm.FileData !== null && selectedStorm.GeoJsonLayers">
                      <v-layout wrap>
                        <v-btn small class="storm-toggle-btn" value="key.Label" :class="{'deselected-toggle': !stormIdHasLayer(key)}" text v-for="key in hurricaneIdDataButtonGroup" :key="key.Label" v-show="selectedStorm.FileData[key.Label]" @click="hurricaneIdData[key.Label].ToggledOn = !hurricaneIdData[key.Label].ToggledOn; toggleStormId(key);">
                          {{key.Label}}
                        </v-btn>
                      </v-layout>
                      <div v-for="key in hurricaneIdData" :key="key.Label + 'legend'" style="padding-top: 1px;">
                        <div v-if="key.LegendKey && stormIdHasLayer(key) && selectedStorm.Legends[key.Label]" style="padding: 0 25px 0 10px;">
                          <v-layout wrap  style="padding: 3px 5px 19px 5px;">
                            <h4 style="position: relative; top: 2px; padding-right: 10px;">{{key.Label}}: </h4>
                            <div v-for="legend in selectedStorm.Legends[key.Label]" :key="legend.Label" style="position: relative; min-width: 100px; height: 25px; text-align: center;">
                              <div style="height: 100%; background-color: transparent;" :style="{'border': '3px solid ' + legend.Border}"></div>
                              <div style="position: absolute; height: 100%; width: 100%; top: 0;" :style="{'opacity': legend.FillOpacity, 'background-color': legend.Fill}"></div>
                              <div style="position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%);">{{legend.Value}}</div>
                            </div>
                          </v-layout>
                        </div>
                      </div>
                      <div v-for="key in hurricaneIdDataInfoToggle" :key="key.Label" v-show="selectedStorm.FileData[key.Label]" style="padding-top: 5px;">
                        <h3>{{key.Label}}</h3>
                        <div v-if="(key.ToggledOn || key.IsLabel) && key.Category === 'subCategories' && selectedStorm.FileData[key.Label]">
                          <div>
                            <v-layout wrap>
                              <v-btn small v-for="(subKey, idx) in selectedStorm.FileData[key.Label]" :key="idx" class="storm-toggle-btn" value="key.Label" :class="{'deselected-toggle': !stormIdHasLayer(key, subKey[0].properties.label, getStormSliderIdx(key.Label, subKey[0].properties.label))}" text @click="toggleStormSubId(key, subKey[0].properties.label, getStormSliderIdx(key.Label, subKey[0].properties.label));" >
                                {{subKey[0].properties.label}}
                              </v-btn>
                            </v-layout>
                            <div v-if="key.UseScrub">
                              <div v-for="(subKey, idx) in selectedStorm.FileData[key.Label]" :key="idx" v-show="stormIdHasLayer(key, subKey[0].properties.label, getStormSliderIdx(key.Label, subKey[0].properties.label))">           
                                <div v-if="selectedStorm.SliderData[key.Label +'_'+ subKey[0].properties.label]" style="width: 100%; padding: 0px 25px 30px 25px;">
                                  <v-layout>
                                    <v-flex>
                                      <v-layout style="padding-bottom: 25px;">
                                        <div style="padding: 0 10px;">
                                          <b>Time Start:</b> {{formatTime(selectedStorm.SliderData[key.Label +'_'+ subKey[0].properties.label].TickData[selectedStorm.SliderData[key.Label +'_'+ subKey[0].properties.label].SliderNum].TimeStart)}}
                                        </div>
                                        <div style="padding: 0 10px;">
                                          <b>Time End:</b> {{formatTime(selectedStorm.SliderData[key.Label +'_'+ subKey[0].properties.label].TickData[selectedStorm.SliderData[key.Label +'_'+ subKey[0].properties.label].SliderNum].TimeEnd)}}
                                        </div>
                                      </v-layout>
                                    </v-flex>
                                    <v-flex style="text-align: right; padding-right: 15px;">
                                      <v-icon v-show="!play" :style="{'color': play? '#1976d2' : '#707070'}" @click="playSelectedStormOverlay(key, subKey[0].properties.label)">play_arrow</v-icon>
                                      <v-icon v-show="play" :style="{'color': !play? '#1976d2' : '#707070'}" @click="stopOverlay()">pause</v-icon>
                                      <span style="font-weight: 900; position: relative; bottom: 3px; font-size: 17px; color: #707070;" @click="overlayPlaySpeedIdx = (overlayPlaySpeedIdx + 1) % overlayPlaySpeeds.length">{{overlayPlaySpeeds[overlayPlaySpeedIdx].label}}</span>
                                      <v-icon :style="{'color': overlayRepeat? '#1976d2' : '#707070'}" @click="overlayRepeat = !overlayRepeat">replay</v-icon>
                                    </v-flex>
                                  </v-layout>
                                  <div style="position: relative;">
                                    <vue-slider :tooltip="'always'" :tooltip-formatter="val => stormSliderTooltipFormat(val, key.Label, subKey[0].properties.label)" @change="toggleStormSlider($event, key, subKey[0].properties.label);" :tooltip-placement="'top'" :duration="0" :min="0" :max="selectedStorm.SliderData[key.Label +'_'+ subKey[0].properties.label].MaxOffset" :adsorb="true" :hideLabel="true" v-model="selectedStorm.SliderData[key.Label +'_'+ subKey[0].properties.label].SliderNum" :marks="selectedStorm.SliderData[key.Label +'_'+ subKey[0].properties.label].GetTicks()" :included="true"></vue-slider>
                                    <div class="slider-day-ticks" :style="{'left': day.offset + '%'}" v-for="day in selectedStorm.SliderData[key.Label +'_'+ subKey[0].properties.label].DayData()" :key="day.day">   
                                      <div class="slider-day-tick"></div>
                                      <div class="slider-day-label">{{day.label}}</div>   
                                    </div>
                                    <div class="slider-event-duration">
                                      <div class="event-duration" :style="getStormDurationOffset(key.Label, subKey[0].properties.label)"></div>
                                    </div>
                                  </div>
                                  <v-layout style="padding-top: 10px;">
                                    <v-flex xs6 hidden-sm-and-up style="text-align: center;">
                                      <v-btn text icon color="grey darken-1" @click="playNextStormSliderFrame(-1, key, subKey[0].properties.label)">
                                        <v-icon dark>skip_previous</v-icon>
                                      </v-btn>
                                    </v-flex>
                                    <v-flex xs6 hidden-sm-and-up style="text-align: center;">
                                      <v-btn text icon color="grey darken-1" @click="playNextStormSliderFrame(1, key, subKey[0].properties.label)">
                                        <v-icon dark>skip_next</v-icon>
                                      </v-btn>
                                    </v-flex>
                                  </v-layout>
                                  <div v-if="selectedStorm.Legends[key.Label]" style="padding-top: 25px;">
                                    <v-layout wrap justify-center style="padding: 3px 5px 19px 5px;">
                                      <div v-for="legend in selectedStorm.Legends[key.Label]" :key="legend.Label" style="position: relative; min-width: 100px; top: 8px; height: 25px; text-align: center;">
                                        <div style="height: 100%; background-color: transparent;" :style="{'border': '3px solid ' + legend.Border}"></div>
                                        <div style="position: absolute; height: 100%; width: 100%; top: 0;" :style="{'opacity': legend.FillOpacity, 'background-color': legend.Fill}"></div>
                                        <div style="position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%);">{{legend.Value}}</div>
                                      </div>
                                    </v-layout>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>               
                        </div>
                      </div>
                      <div style="padding: 15px 0;">
                        <v-layout>
                          <h3>Alternate Tracks</h3>
                          <div @click="toggleStormTrackAll()" style="position: relative; bottom: 18px; padding-left: 20px; margin: 0;">
                            <v-checkbox :value="isShowingStormTracks() > -1" readonly hide-details :indeterminate="isShowingStormTracks() == 0" :label="isShowingStormTracks() == 1 ? 'Toggle All Off' : 'Toggle All On'"></v-checkbox>
                          </div>
                          <v-checkbox label="Show Points" v-model="showTrackPoints" hide-details style="padding-top: 0; margin-top: 0; padding-left: 25px;"></v-checkbox>
                        </v-layout>
                        <div v-if="selectedStorm.LoadingTrackData" style="text-align: center; width: 100%;">
                          <v-progress-circular style="" :size="55" :width="5" indeterminate color="primary"/>
                        </div>
                        <div v-else-if="Object.keys(selectedStorm.TrackData).length == 0" style="text-align: center; width: 100%;">
                          <h4>No Alternate Track Data</h4>
                        </div>
                        <div v-else>
                          <div v-for="model in selectedStorm.TrackData" :key="model.Name" style="padding: 5px 15px; border-bottom: 1px solid grey;">
                            <v-layout wrap>
                              <div :style="{'border': '2px solid' + model.Color}" @click="toggleStormTrackAll(model.Name)" style="cursor: pointer; width: 88px; height: 28px; position: relative; top: -2px; margin: 3px 8px 3px 0;">
                                <div :style="{'background-color': model.Color}" style="width: 100%; height: 100%; opacity: .5;"></div>
                                <h4 style="position: absolute; width: 100%; text-align: center; left: 0; top: 0px;">
                                  <span style="position: relative;">{{model.Name}} </span>
                                  <v-icon>{{getTrackLabelIcon(model.Name)}}</v-icon>
                                </h4>
                              </div>
                              <v-btn small v-for="subModel in model.Models" @click="toggleStormTrackLayer(subModel)" :key="subModel.Name" text class="storm-toggle-btn" value="key.Label" :class="{'deselected-toggle': !map.hasLayer(subModel.LinesGeoJson)}">
                                {{subModel.Name}}
                              </v-btn>
                            </v-layout>                
                          </div>
                        </div>                    
                      </div>
                    </div> 
                  </div>  
                </div>
              </div>
            </div>
<!-- END OVERLAYS -->
          </div>
        </div>
        <div class="overview-toggles" v-if="showMap">
          <a v-if="!showOverlaySelect">
            <div class="overview-toggle" @click="showOverlaySelect = true; showWeatherOverlaySelect = true; stopOverlay();">
              <v-icon color="#000" style="position: relative; top: 2px;">filter_drama</v-icon>
            </div>
          </a>
          <a v-if="!showOverlaySelect">
            <div class="overview-toggle" @click="showOverlaySelect = true; showHurricaneOverlaySelect = true; stopOverlay();">
              <svg style="width: 16px; position: relative; top: 4px;" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512">
                <path d="M176 96l24.5-74.8C204 10.6 195.9 0 185.1 0c-.7 0-1.3 0-2 .1C80 12.4 0 101.6 0 208c0 114.9 93.1 208 208 208l-24.5 74.8c-3.5 10.6 4.6 21.2 15.4 21.2.7 0 1.3 0 2-.1C304 499.6 384 410.4 384 304c0-114.9-93.1-208-208-208zm46.3 379.2l16.1-49.3 13.7-42H208c-97 0-176-79-176-176 0-81.1 54.2-150.7 129.7-171.2L145.6 86l-13.7 42H176c97 0 176 79 176 176 0 81.1-54.2 150.7-129.7 171.2zM192 184c-39.8 0-72 32.2-72 72s32.2 72 72 72 72-32.2 72-72-32.2-72-72-72zm0 112c-22.1 0-40-17.9-40-40s17.9-40 40-40 40 17.9 40 40-17.9 40-40 40z"></path></svg>
            </div>
          </a>
          <a v-if="selectedDay">
            <div class="overview-toggle" @click="zoomToFit(geoJsonLayer)">
              <v-icon style="position: relative; top: 2px !important;" color="#000">zoom_out_map</v-icon>
            </div>
          </a>
          <a v-if="showMap">
            <div class="overview-toggle" @click="swapMapTiles()">
              <v-icon color="#000" style="position: relative; top: 2px;">map</v-icon>
            </div>
          </a>
        </div>
        <v-progress-circular class="progress-circle-loading" :size="55" :width="5" indeterminate color="primary" :style="{'left': '50%'}" v-if="loadingAlerts" ></v-progress-circular>
        <v-progress-circular class="progress-circle-refreshing" :size="30" :width="5" indeterminate color="primary" v-if="refreshing" ></v-progress-circular>
        <div class="hover-summary" v-if="hoveredMarkerItem">
          <v-layout row>
            <v-flex xs6>
              <div><strong>{{hoveredMarkerItem.riskcategory}}:</strong> {{hoveredMarkerItem.normalizedrisk}}</div>
            </v-flex>
            <v-flex xs6 style="min-width: fit-content; padding-left: 10px">
              <div  style="white-space: nowrap;"><strong>{{deliverabilityAlertTypesToggle[hoveredMarkerItem.type].label}}</strong></div>
            </v-flex>
          </v-layout>
          <div v-if="hoveredMarkerItem.event && hoveredMarkerItem.event != hoveredMarkerItem.summary">{{hoveredMarkerItem.event}}</div>
          <div>{{hoveredMarkerItem.summary}}</div>
        </div>
      </div>
    </v-slide-y-transition>
  </v-container>
<!-- eslint-enable -->
</template>

<script>
import deliverabilityAlertsMapModule, {
  DELIVERABILITY_ALERTS_MAP_NAMESPACE
} from "./store/deliverabilityAlertsMapStore";
import { mapGetters } from "vuex";
import VueSlider from "vue-slider-component";
import "vue-slider-component/theme/default.css";
import moment from "moment";
import $ from "jquery";
// eslint-disable-next-line
import bingTileLayer from "leaflet-bing-layer";
// eslint-disable-next-line
import * as d3 from "d3";

export default {
  name: "DeliverabilityAlertsMap",
  components: {
    VueSlider
  },
  computed: {
    ...mapGetters(DELIVERABILITY_ALERTS_MAP_NAMESPACE, [
      "alertsData",
      "alertTypes",
      "loadingAlerts",
      "loadingFiles",
      "loadingHurricaneData",
      "overlayFiles",
      "hurricaneData"
    ]),
    deliverabilityAlertTypesToggleArray() {
      var arr = [];
      for (var key in this.deliverabilityAlertTypesToggle)
        arr.push(this.deliverabilityAlertTypesToggle[key]);
      return arr;
    },
    riskCategoriesToggleArray() {
      var arr = [];
      for (var key in this.riskCategoriesToggle) arr.push(key);
      return arr;
    },
    hurricaneIdDataButtonGroup() {
      var buttons = [];
      for (var key in this.hurricaneIdData) {
        if (this.hurricaneIdData[key].ToggleBtn)
          buttons.push(this.hurricaneIdData[key]);
      }
      return buttons;
    },
    hurricaneIdDataInfoToggle() {
      var buttons = [];
      for (var key in this.hurricaneIdData) {
        if (!this.hurricaneIdData[key].ToggleBtn)
          buttons.push(this.hurricaneIdData[key]);
      }
      return buttons;
    }
  },
  methods: {
    addGeoJsonEvents() {
      var self = this;
      this.geoJsonLayer
        .on("click", function(c) {
          self.setSelectedAlertMarker(c.layer.feature.properties.alertid);
          self.openDetailsById(c.layer.feature.properties.alertid);
          setTimeout(() => {
            var lowestOffsetTop;
            var element = document.getElementById(
              "overview-data-" + c.layer.feature.properties.alertid
            );
            if (!lowestOffsetTop) lowestOffsetTop = element.offsetTop;
            if (element.offsetTop < lowestOffsetTop)
              lowestOffsetTop = element.offsetTop;
            var tableElement = document.getElementById("grid-container");
            var selectorsElement = document.getElementById("filter-selectors");
            tableElement.scrollTop =
              lowestOffsetTop + selectorsElement.offsetHeight;
          }, 500);
        })
        .on("mouseover", function(c) {
          self.setSelectedAlertMarker(c.layer.feature.properties.alertid);
          self.hoveredMarkerItem = c.layer.feature.properties;
        })
        .on("mouseout", function(c) {
          self.removeSelectedAlertMarker();
          self.hoveredMarkerItem = null;
        });
    },
    addMapLayer(geoJson, id) {
      if (geoJson) {
        geoJson.addTo(this.map);
        this.toggleLegendLayer(false, id, true);
      }
    },
    camelToSpaceCase(s) {
      return s.replace(/([A-Z])/g, " $1").replace(/^./, function(str) {
        return str.toUpperCase();
      });
    },
    clearLayers() {
      if (this.currentOverlay) {
        this.currentOverlay.children.forEach(x => {
          if (x.geoJsonLayer)
            if (
              this.map.hasLayer(x.geoJsonLayer) &&
              x.timeOffset !== this.sliderNum
            ) {
              this.map.removeLayer(x.geoJsonLayer);
            }
        });
      }
    },
    closeAllExpanded: function() {
      if (this.$refs.alertsDataTable)
        for (var key in this.$refs.alertsDataTable.expanded)
          this.$refs.alertsDataTable.expanded[key] = false;
    },
    copyZipCodeListToClipboard(zipList) {
      var text = zipList.join();

      if (window.clipboardData && window.clipboardData.setData) {
        return window.clipboardData.setData("Text", text);
      } else if (
        document.queryCommandSupported &&
        document.queryCommandSupported("copy")
      ) {
        var textarea = document.createElement("textarea");
        textarea.textContent = text;
        textarea.style.position = "fixed";
        document.body.appendChild(textarea);
        textarea.select();
        try {
          return document.execCommand("copy");
        } catch (ex) {
          console.warn("Copy to clipboard failed.", ex);
          return false;
        } finally {
          document.body.removeChild(textarea);
        }
      }
    },
    createDayGeoJson(data) {
      if (this.geoJsonLayer) this.map.removeLayer(this.geoJsonLayer);
      var geoJsonData = {
        type: "FeatureCollection",
        features: [],
        properties: {}
      };
      for (var alertId in data) {
        if (
          this.deliverabilityAlertTypesToggle[data[alertId].properties.type]
            .toggle === true &&
          this.riskCategoriesToggle[data[alertId].properties.riskcategory]
            .toggle === true
        )
          geoJsonData.features.push(data[alertId]);
      }

      // Sort by normalized risk so Higher Risk alerts layer on top
      geoJsonData.features = geoJsonData.features.sort(function(a, b) {
        if (a.properties.normalizedrisk > b.properties.normalizedrisk) return 1;
        else if (a.properties.normalizedrisk === b.properties.normalizedrisk)
          return 0;
        else return -1;
      });

      var self = this;
      // eslint-disable-next-line
      this.geoJsonLayer = L.geoJson(geoJsonData, {
        style: function(feature) {
          var styles = {
            weight: 1,
            fillOpacity: 0.4,
            fillRule: "nonzero",
            color:
              self.riskCategoriesToggle[feature.properties.riskcategory].stroke,
            fillColor:
              self.riskCategoriesToggle[feature.properties.riskcategory].fill
          };
          if (feature.properties.riskcategory === "Medium")
            styles.fillOpacity = 0.2;
          return styles;
        }
      });
      this.geoJsonLayer.addTo(this.map);
      this.addGeoJsonEvents();
    },
    createDayObjects(alertData) {
      this.alertDayData = {};
      this.alertDaySelectData = [];
      for (var day in alertData.deliverabilityForecast) {
        if (!this.selectedDay) this.selectedDay = day;
        var dayData = {};
        var tableData = [];

        alertData.deliverabilityForecast[day].forEach(alertId => {
          var data = alertData.alertCollection.features.find(x => {
            return x.properties.alertid === alertId;
          });
          if (data) {
            dayData[alertId] = data;
            tableData.push(data.properties);
          }
        });
        this.alertDayData[day] = {
          Key: day,
          Data: dayData,
          Summary: this.getDaySummaryData(dayData),
          TableData: tableData
        };

        this.alertDaySelectData.push({
          Label: day.slice(0, 10),
          Key: day
        });
      }
    },
    createOverlaysTree: function(fileList) {
      this.overlayTreeData = [];
      var fileTree = {};
      fileList.forEach(x => {
        x.forecastPointInTimeHours = this.getForecastPointInTimeHours(x);
        // For Tropical Cyclone DataType
        if (x.dataType.includes("Incremental"))
          x.enumerationType = "Incremental";
        else if (x.dataType.includes("Cumulative"))
          x.enumerationType = "Cumulative";

        x.weatherEvent = x.displayName;
        if (!fileTree[x.region]) fileTree[x.region] = {};
        if (!fileTree[x.region][x.weatherEvent])
          fileTree[x.region][x.weatherEvent] = {};
        if (!fileTree[x.region][x.weatherEvent][x.enumerationType])
          fileTree[x.region][x.weatherEvent][x.enumerationType] = [];
        fileTree[x.region][x.weatherEvent][x.enumerationType].push(x);
      });
      var i = 1;
      for (var region in fileTree) {
        var regionChildren = [];

        for (var weatherEvent in fileTree[region]) {
          var weatherEventChildren = [];
          for (var enumerationType in fileTree[region][weatherEvent]) {
            var enumerationTypeChildren = [];
            var dataTicks = [];
            var fileForecastTimeUtc = "";
            fileTree[region][weatherEvent][enumerationType].forEach(file => {
              var hasTimeDup = enumerationTypeChildren.filter(
                x => x.timeOffset === file.forecastPointInTimeHours
              );
              if (hasTimeDup.length === 0) {
                enumerationTypeChildren.push({
                  id: i,
                  name: file.fileForecastTimeUtc,
                  data: file,
                  timeOffset: file.forecastPointInTimeHours,
                  File_ID:
                    "id_" +
                    this.stripClass(region) +
                    this.stripClass(enumerationType) +
                    this.stripClass(file.filePath),
                  Layer_IDs: []
                });
                dataTicks.push(file.forecastPointInTimeHours);
                i++;
                fileForecastTimeUtc = file.fileForecastTimeUtc;
              }
            });
            weatherEventChildren.push({
              id: i,
              name: this.camelToSpaceCase(enumerationType),
              children: this.sort(enumerationTypeChildren, "timeOffset"),
              label:
                weatherEvent +
                ": " +
                this.camelToSpaceCase(enumerationType),
              ticks: _.uniq(
                _.cloneDeep(dataTicks).sort(function(a, b) {
                  return a - b;
                })
              ),
              fileForecastTimeUtc: fileForecastTimeUtc
            });
            i++;
          }
          regionChildren.push({
            id: i,
            name: weatherEvent,
            children: this.sort(weatherEventChildren, "name"),
            label: weatherEvent
          });
          i++;
        }
        this.overlayTreeData.push({
          id: i,
          name: this.camelToSpaceCase(region),
          children: this.sort(regionChildren, "name"),
          key: region
        });
        i++;
      }
      this.overlayTreeData = this.sort(this.overlayTreeData, "name");
    },
    formatTime(timeStr) {
      if (timeStr) {
        return moment(timeStr)
          .tz(this.selectedTimezone)
          .format("YYYY-MM-DD HH:mm");
      }
    },
    getCurrentFileDelayDuration() {
      var idx = this.getSliderNumIndex(this.sliderNum);
      if (idx > -1) {
        var child = this.currentOverlay.children[idx];
        if (child.eventDuration) return child.eventDuration;
      }
      return 0;
    },
    getCurrentOverlayDaySpacerData(startTime, maxOffset) {
      var dayWidth = 100 / (maxOffset / 24);
      var hoursToTmrw = moment(moment(startTime).add(1, "days"))
        .tz(this.selectedTimezone)
        .hours(0)
        .minutes(0)
        .seconds(0);
      var duration = moment.duration(hoursToTmrw.diff(moment(startTime)));
      var hours = duration.asHours();
      var start = (hours / 24) * dayWidth;
      var spacers = [];
      for (
        let i = 0;
        i < maxOffset / 24 && start + i * dayWidth <= 100.1;
        i++
      ) {
        spacers.push({
          day: i,
          label: moment(startTime)
            .add(i + 1, "days")
            .tz(this.selectedTimezone)
            .format("ddd M-D"),
          offset: start + i * dayWidth
        });
      }
      return spacers;
    },
    getCurrentShownTime(startTime, hoursOffset) {
      if (hoursOffset < 0) hoursOffset = 0;
      return moment(startTime)
        .add(hoursOffset, "hours")
        .tz(this.selectedTimezone)
        .format("MM-DD HH:mm");
    },
    getDaySummaryData(dayData) {
      var summary = {
        alertType: {},
        riskCategory: {},
        total: 0
      };
      for (var cat in this.riskCategoriesToggle) {
        summary.riskCategory[this.riskCategoriesToggle[cat].label] = {
          label: this.riskCategoriesToggle[cat].label,
          total: 0
        };
      }
      this.alertTypes.forEach(x => {
        summary.alertType[x.Name] = {
          label: x.Description,
          total: 0,
          key: x.Name
        };
      });
      for (var alertId in dayData) {
        summary.total++;
        summary.alertType[dayData[alertId].properties.type].total++;
        summary.riskCategory[dayData[alertId].properties.riskcategory].total++;
      }
      return summary;
    },
    getDurationOffset() {
      var duration = this.getCurrentFileDelayDuration();
      var hourWidth =
        100 / this.currentOverlay.ticks[this.currentOverlay.ticks.length - 1];
      var diff = this.sliderNum - duration;
      if (diff < 0) duration += diff;
      var width = hourWidth * duration;
      var left = hourWidth * (this.sliderNum - duration);
      if (width < 0) width = 0;
      if (left < 0) left = 0;
      return {
        left: `${left}%`,
        width: `${width}%`
      };
    },
    getFilesInChunks(data) {
      var fileNames = [];
      var indexes = [];
      data.children.forEach((x, i) => {
        if (x.geoJsonLayer == null) {
          fileNames.push(x.data.filePath);
          indexes.push(i);
        } else {
          if (x.timeOffset === this.sliderNum) {
            if (!this.map.hasLayer(x.geoJsonLayer))
              x.geoJsonLayer.addTo(this.map);
            this.showCollectionFileId = x.File_ID;
            this.toggleLegendLayer(true, x.File_ID);
          }
        }
        if (fileNames.length === 5) {
          this.getOverlayFileData(fileNames.join(","), data, indexes);
          fileNames = [];
          indexes = [];
        }
      });
      if (fileNames.length > 0)
        this.getOverlayFileData(fileNames.join(","), data, indexes);
    },
    getForecastPointInTimeHours(file) {
      return moment(file.forecastPointInTimeUtc).diff(
        moment(file.fileForecastTimeUtc),
        "hours"
      );
    },
    getOverlayFileData(fileName, dataType, indexes) {
      return this.$store
        .dispatch(
          `${DELIVERABILITY_ALERTS_MAP_NAMESPACE}/loadOverlayFile`,
          fileName
        )
        .then(x => {
          return this.setOverlayFiles(x, dataType, indexes);
        });
    },
    getSliderNumIndex(sliderNum) {
      var index = -1;
      this.currentOverlay.children.forEach((x, i) => {
        if (x.data.forecastPointInTimeHours === sliderNum) index = i;
      });
      return index;
    },
    getTableHeightPercent() {
      if (!this.showGrid) return "0%";
      else if (!this.showMap) return "100%";
      else if (window.innerWidth < 760) return "50%";
      return "40%";
    },
    getWeatherEvent(dataType) {
      var event = dataType.split(/(\d+)/);
      if (dataType.includes("ProbabalisticTropicalCycloneSurfaceWindSpeeds"))
        return `${event[0]} ${event[1]}kts`;
      else return event[0];
    },
    initAlertTypes() {
      this.deliverabilityAlertTypesToggle = {};
      this.alertTypes.forEach(x => {
        this.deliverabilityAlertTypesToggle[x.Name] = {
          toggle: true,
          label: x.Description,
          key: x.Name
        };
      });
    },
    initDeliverabilityAlertsMap() {
      /* eslint-disable */
      this.map = L.map("map", {
        keyboard: false,
        center: [37, -97],
        zoom: 4.5,
        maxZoom: 18,
        minZoom: 0,
        zoomSnap: 0,
        zoomDelta: 0.85,
        wheelPxPerZoomLevel: 40,
        fadeAnimation: false,
        markerZoomAnimation: false,
        worldCopyJump: true
      }).setView([37, -97], 5);
      this.zoomToFit({
        getBounds: () => [[24.7433195, -124.7844079], [49.3457868, -66.9513812]]
      });
      this.swapMapTiles();
      var self = this;
      this.map.on("click", () => {
        self.removeSelectedAlertMarker();
        self.hoveredMarkerItem = null;
        self.stopOverlay();
      });
      this.map.on("zoomstart", () => {
        self.clearLayers();
      });
      this.map.on("movestart", () => {
        self.resumePlay = self.play;
        self.stopOverlay();
      });
      this.map.on("moveend", () => {
        if (self.resumePlay) {
          if (self.currentOverlay && self.currentTab === 1)
            self.playSelectedOverlay(self.sliderNum);
          else if (self.selectedStorm && self.currentTab === 2)
            self.playSelectedStormOverlay(
              self.selectedStorm.ScrubIdItem,
              self.selectedStorm.SubScrubId
            );
          else {
            self.play = false;
            self.stopOverlay();
          }
        }
        self.resumePlay = false;
      });
    },
    initTimeZones() {
      this.timeZones.forEach(x => {
        var offset =
          moment()
            .tz(x.Code)
            .utcOffset() / 60;
        x.Label += ` (${offset >= 0 ? "+" : ""}${offset}:00)`;
      });
    },
    loadAlertTypes() {
      return this.$store
        .dispatch(`${DELIVERABILITY_ALERTS_MAP_NAMESPACE}/loadAlertTypes`)
        .then(x => {
          this.initAlertTypes();
        });
    },
    loadHurricaneStormData(atcfId) {
      return this.$store
        .dispatch(
          `${DELIVERABILITY_ALERTS_MAP_NAMESPACE}/loadHurricaneStormData`,
          atcfId
        )
        .then(x => {
          return x;
        });
    },
    loadHurricaneStormList() {
      return this.$store
        .dispatch(
          `${DELIVERABILITY_ALERTS_MAP_NAMESPACE}/loadHurricaneStormList`
        )
        .then(x => {
          this.createHurricaneTree(this.hurricaneData);
        });
    },
    loadHurricaneStormTrackData(atcfId) {
      return this.$store
        .dispatch(
          `${DELIVERABILITY_ALERTS_MAP_NAMESPACE}/loadHurricaneStormTrackData`,
          atcfId
        )
        .then(x => {
          return x;
        });
    },
    loadMapData(disableCache) {
      return this.$store
        .dispatch(
          `${DELIVERABILITY_ALERTS_MAP_NAMESPACE}/loadMapData`,
          disableCache
        )
        .then(x => {
          this.createDayObjects(this.alertsData);
          this.setFilteredTotalSummary();
        });
    },
    loadMapOverlayFiles() {
      return this.$store
        .dispatch(`${DELIVERABILITY_ALERTS_MAP_NAMESPACE}/loadMapOverlayFiles`)
        .then(() => {
          this.createOverlaysTree(this.overlayFiles);
        });
    },
    openDetailsById(alertId) {
      this.closeAllExpanded();
      this.$set(this.$refs.alertsDataTable.expanded, alertId, true);
    },
    playNextOverlayFrame(stepDir) {
      if (this.currentOverlay.ticks)
        if (this.currentOverlay.ticks.length > 0) {
          var idx = this.currentOverlay.ticks.indexOf(this.sliderNum) + stepDir;
          if (idx < 0) idx = this.currentOverlay.ticks.length - 1;
          if (idx > this.currentOverlay.ticks.length - 1) idx = 0;
          this.sliderNum = this.currentOverlay.ticks[idx];
          this.sliderChange(
            this.currentOverlay.ticks[idx],
            this.currentOverlay
          );
        }
    },
    playOverlay(index) {
      var self = this;
      if (this.play)
        this.overlayTimeout = setTimeout(() => {
          if (self.currentOverlay.children.length > index) {
            if (self.currentOverlay.children[index]) {
              // eslint-disable-next-line
              self.sliderNum = self.currentOverlay.children[index].data.forecastPointInTimeHours;
              self.sliderChange(self.sliderNum, self.currentOverlay);

              index++;
              if (index < self.currentOverlay.children.length)
                self.playOverlay(index);
              else {
                if (self.overlayRepeat) self.playOverlay(0);
                else self.play = false;
              }
            }
          }
        }, this.overlayPlaySpeeds[this.overlayPlaySpeedIdx].duration);
    },
    playSelectedOverlay(slideNum) {
      this.stopOverlay();
      this.play = true;
      var index = -1;
      if (this.currentOverlay)
        this.currentOverlay.children.forEach((x, i) => {
          if (x.data.forecastPointInTimeHours === slideNum) index = i;
        });
      if (index > -1) {
        this.playOverlay(index);
      } else {
        this.playOverlay(0);
      }
    },
    recreateDayGeoJson() {
      if (this.selectedDay)
        this.createDayGeoJson(this.alertDayData[this.selectedDay].Data);
    },
    removeSelectedAlertMarker() {
      if (this.selectedAlertMarker)
        this.map.removeLayer(this.selectedAlertMarker);
    },
    selectOverlay(enumType, region) {
      this.play = false;
      this.showOverlaySelect = false;
      this.showWeatherOverlaySelect = false;
      if (this.currentOverlay) {
        this.currentOverlay.Selected = false;
        this.currentOverlay.children.forEach(x => {
          if (x.geoJsonLayer)
            if (this.map.hasLayer(x.geoJsonLayer))
              this.map.removeLayer(x.geoJsonLayer);
        });
        this.currentOverlay = null;
      }
      if (!enumType) return;
      this.sliderNum = enumType.ticks[0];
      this.currentOverlay = enumType;
      this.currentOverlay.Selected = true;
      this.currentTab = 1;
      setTimeout(() => {
        this.zoomToFit(this.regions[region]);
      }, 500);
      this.getFilesInChunks(enumType);
    },
    setFilteredTotalSummary() {
      for (var day in this.alertDayData) {
        this.filteredTotalSummary[day] = {
          deliverabilityAlertTypes: {},
          riskCategories: {},
          total: 0
        };
        this.alertDayData[day].TableData.forEach(x => {
          if (
            this.deliverabilityAlertTypesToggle[x.type].toggle === true &&
            this.riskCategoriesToggle[x.riskcategory].toggle === true
          ) {
            this.filteredTotalSummary[day].total++;
            if (this.filteredTotalSummary[day].deliverabilityAlertTypes[x.type])
              this.filteredTotalSummary[day].deliverabilityAlertTypes[x.type]++;
            else
              // eslint-disable-next-line
              this.filteredTotalSummary[day].deliverabilityAlertTypes[x.type] = 1
            if (this.filteredTotalSummary[day].riskCategories[x.riskcategory])
              this.filteredTotalSummary[day].riskCategories[x.riskcategory]++;
            else
              this.filteredTotalSummary[day].riskCategories[x.riskcategory] = 1;
          }
        });
      }
      this.$forceUpdate();
    },
    setOverlayFiles(fileData, enumType, indexes) {
      fileData.forEach((x, i) => {
        var overlay = enumType.children.find(
          y => y.data.filePath === x.FileName
        );
        if (overlay) {
          var self = this;
          var data = JSON.parse(x.FileData);
          if (data.properties.StatisticalTimeIntervalHours)
            overlay.eventDuration =
              data.properties.StatisticalTimeIntervalHours;
          enumType.Legend = this.setOverlayLegend(
            enumType.Legend,
            data,
            indexes[i]
          );
          data.features.forEach(f => {
            overlay.Layer_IDs.push(self.stripClass(f.id));
            // delete f.properties["ZipCodeList"];
          });
          // eslint-disable-next-line
          overlay.geoJsonLayer = L.geoJson(data, {
            style: function(feature) {
              var styles = {
                className:
                  "ID_" + self.stripClass(feature.id) + " " + overlay.File_ID
              };
              for (var key in feature.properties) {
                if (key !== "ZipCodeList")
                  if (key === "fill") {
                    styles["color"] = feature.properties[key];
                  } else styles[self.toCamel(key)] = feature.properties[key];
              }
              return styles;
            }
          });

          if (
            enumType === this.currentOverlay &&
            overlay.timeOffset === this.sliderNum
          ) {
            overlay.geoJsonLayer.addTo(this.map);
            this.showCollectionFileId = overlay.File_ID;
            this.toggleLegendLayer(true, overlay.File_ID);
            this.$forceUpdate();
          }
        }
      });
    },
    setOverlayLegend(legend, collection, index) {
      if (!legend) legend = [];
      collection.features.forEach(f => {
        if (f.properties.Id) {
          var copy = legend.find(
            x => x.layerId === "ID_" + this.stripClass(f.properties.Id)
          );
          if (!copy) {
            var legendItem = {
              Label: f.properties.Id,
              Fill: f.properties.fill,
              Stroke: f.properties.stroke,
              Opacity: f.properties["fill-opacity"],
              ValueLabelList: {},
              layerId: "ID_" + this.stripClass(f.properties.Id),
              showLayer: true
            };
            if (collection.properties.ValueUnits)
              legendItem.ValueLabelList["idx_" + index] =
                this.camelToSpaceCase(collection.properties.ValueUnits) +
                ": " +
                f.properties.Value;
            legend.push(legendItem);
            this.$forceUpdate();
          } else {
            if (collection.properties.ValueUnits) {
              copy.ValueLabelList["idx_" + index] =
                this.camelToSpaceCase(collection.properties.ValueUnits) +
                ": " +
                f.properties.Value;
            }
          }
        }
      });
      return legend;
    },
    setSelectedAlertMarker(alertId) {
      this.removeSelectedAlertMarker();
      if (this.alertDayData[this.selectedDay].Data[alertId]) {
        // eslint-disable-next-line
        this.selectedAlertMarker = L.geoJson(
          this.alertDayData[this.selectedDay].Data[alertId],
          {
            style: function(feature) {
              return {
                color: "black",
                fillRule: "nonzero",
                pointerEvents: "none",
                className: "no-pointer-events"
              };
            }
          }
        );
        this.selectedAlertMarker.addTo(this.map);
      }
    },
    sliderChange($event, dataType) {
      if (this.showCollectionFileId)
        this.toggleLegendLayer(false, this.showCollectionFileId, true);
      var child = dataType.children.find(
        x => x.data.forecastPointInTimeHours === $event
      );
      if (child) {
        this.showCollectionFileId = child.File_ID;
        if (child.geoJsonLayer)
          if (!this.map.hasLayer(child.geoJsonLayer))
            child.geoJsonLayer.addTo(this.map);
        this.toggleLegendLayer(true, this.showCollectionFileId);
      }
    },
    sliderTooltipFormat(val) {
      var duration = this.getCurrentFileDelayDuration();
      if (duration > 0)
        return `${val - duration >= 0 ? val - duration : 0}-${val}`;
      return val;
    },
    sort(arr, key) {
      return arr.sort(function(a, b) {
        if (a[key] && !b[key]) return 1;
        else if (!a[key] && b[key]) return -1;
        else if (!a[key] && !b[key]) return 0;
        return a[key]
          .toString()
          .toLowerCase()
          .localeCompare(b[key].toString().toLowerCase(), undefined, {
            numeric: true,
            sensitivity: "base"
          });
      });
    },
    stopOverlay() {
      this.play = false;
      if (this.overlayTimeout) clearTimeout(this.overlayTimeout);
    },
    stripClass(s) {
      return s.replace(/\W/g, "");
    },
    swapMapTiles() {
      if (this.tileLayer) this.map.removeLayer(this.tileLayer);

      if (this.currentTileLayer === "street") {
        // eslint-disable-next-line
        this.tileLayer = L.tileLayer.bing({
          bingMapsKey: process.env.VUE_APP_BING_MAPS_KEY,
          imagerySet: "AerialWithLabels"
        });
        this.currentTileLayer = "satellite";
      } else if (
        this.currentTileLayer === "satellite" ||
        !this.currentTileLayer
      ) {
        // eslint-disable-next-line
        this.tileLayer = L.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png");
        this.currentTileLayer = "street";
      }

      if (this.tileLayer) this.map.addLayer(this.tileLayer);
    },
    toCamel(s) {
      return s.replace(/([-_][a-z])/gi, x => {
        return x
          .toUpperCase()
          .replace("-", "")
          .replace("_", "");
      });
    },
    toggleLegendLayer($event, key, important) {
      var sheet = document.getElementById("overlay-layer-styles").sheet;
      var oldStyleIndex = -1;
      for (let i = 0; i < sheet.cssRules.length; i++) {
        if (sheet.cssRules[i].selectorText === "." + key) {
          oldStyleIndex = i;
          i = sheet.cssRules.length;
        }
      }
      if (oldStyleIndex > -1) sheet.deleteRule(oldStyleIndex);
      sheet.insertRule(
        // eslint-disable-next-line
        "." + key + " { display:" + ($event ? "block" : "none !important" ) + "; }", sheet.cssRules.length
      );
    },
    zoomToBounds(bounds) {
      if (bounds.length > 0) {
        var map = document.getElementById("map");
        var paddingBottom = 100;
        if (this.showGrid) paddingBottom = map.offsetHeight * 0.5;
        this.map.fitBounds(bounds, {
          paddingTopLeft: [100, 100],
          paddingBottomRight: [100, paddingBottom]
        });
      }
    },
    zoomToFit(layer) {
      if (layer) {
        var grid = document.getElementById("grid-container");
        var standardPadding = 25;
        var paddingBottom = standardPadding;
        if (this.showGrid) paddingBottom = grid.offsetHeight + standardPadding;
        this.map.fitBounds(layer.getBounds(), {
          paddingTopLeft: [standardPadding, standardPadding],
          paddingBottomRight: [standardPadding, paddingBottom]
        });
      }
    },
    // ------------------------------------------------------------------------------------------
    playStormOverlay(idItem, subCategoryId) {
      if (this.play)
        this.overlayTimeout = setTimeout(() => {
          this.playNextStormSliderFrame(1, idItem, subCategoryId, true);
          this.playStormOverlay(idItem, subCategoryId);
        }, this.overlayPlaySpeeds[this.overlayPlaySpeedIdx].duration);
    },
    playSelectedStormOverlay(idItem, subCategoryId) {
      this.stopOverlay();
      this.play = true;
      this.playStormOverlay(idItem, subCategoryId);
    },
    toggleHurricaneShowDetail(selectedStorm) {
      selectedStorm.showDetail = !selectedStorm.showDetail;
      this.$forceUpdate();
    },
    getStormDurationOffset(itemId, subCategoryId) {
      // eslint-disable-next-line
      var durationData = this.selectedStorm.SliderData[`${itemId}_${subCategoryId}`];
      var duration = durationData.TickData[durationData.SliderNum].Duration;
      var hourWidth = 100 / durationData.MaxOffset;
      var diff = durationData.SliderNum - duration;
      if (diff < 0) duration += diff;
      var width = hourWidth * duration;
      var left = hourWidth * diff;
      if (width < 0) width = 0;
      if (left < 0) left = 0;
      return {
        left: `${left}%`,
        width: `${width}%`
      };
    },
    getStormListStyle(storm) {
      if (this.selectedStorm) {
        if (this.selectedStorm.atcfId === storm.atcfId)
          return {
            "background-color": "#000",
            color: "#fff"
          };
      }
      return {
        "background-color": "#fff",
        color: "#000"
      };
    },
    stormSliderTooltipFormat(val, itemId, subCategoryId) {
      var tickData = this.selectedStorm.SliderData[`${itemId}_${subCategoryId}`]
        .TickData[val];
      return `${tickData.OffsetStart}-${tickData.OffsetEnd}`;
    },
    createHurricaneTree(treeData) {
      var hurricaneTree = {};
      var hurricaneOverviewFeatures = [];
      treeData.stormSummaryList.forEach(x => {
        if (!hurricaneTree[x.region])
          hurricaneTree[x.region] = {
            id: this.stripClass(x.region),
            name: x.region,
            children: [],
            key: this.stripClass(x.region)
          };
        if (x.currentForecast)
          hurricaneOverviewFeatures.push(x.currentForecast);
        hurricaneTree[x.region].children.push(x);
      });
      this.hurricaneTreeData = [];
      for (var key in hurricaneTree) {
        this.hurricaneTreeData.push(hurricaneTree[key]);
      }

      this.hurricaneOverviewLayer = this.getFeatureGeoJson({
        type: "FeatureCollection",
        features: hurricaneOverviewFeatures,
        properties: {}
      });
      this.hurricaneOverviewLayer.addTo(this.map);
    },
    selectStorm(storm) {
      if (this.selectedStorm) {
        this.drawStoreDefaultLayers(true);
        this.selectedStorm.Selected = false;
        this.selectedStorm = null;
      }
      if (!storm) return;
      this.showOverlaySelect = false;
      this.showHurricaneOverlaySelect = false;
      this.selectedStorm = storm;
      storm.Selected = true;
      storm.showDetail = false;
      if (!storm.currentForecast)
        storm.currentForecast = {
          properties: {}
        };
      if (!storm.FileData) {
        storm.FileData = {};
        storm.GeoJsonLayers = {};
        storm.TempGeoJson = {};
        storm.SliderData = {};
        storm.ZoomBounds = [];
        storm.TrackData = {};

        storm.LoadingData = true;
        this.loadHurricaneStormData(storm.atcfId).then(x => {
          storm.LoadingData = false;
          this.setStormFileData(storm, x);
        });
        storm.LoadingTrackData = true;
        this.loadHurricaneStormTrackData(storm.atcfId).then(x => {
          storm.LoadingTrackData = false;
          this.setStormTrackData(storm, x);
        });
      } else {
        this.drawStoreDefaultLayers();
        this.zoomToBounds(this.selectedStorm.ZoomBounds);
      }
    },
    toggleHurricaneOverviewLayer() {
      if (this.map.hasLayer(this.hurricaneOverviewLayer))
        this.map.removeLayer(this.hurricaneOverviewLayer);
      else this.hurricaneOverviewLayer.addTo(this.map);
    },
    drawStoreDefaultLayers(clear) {
      if (clear) this.toggleStormTracks();
      for (var idItem in this.hurricaneIdData) {
        this.toggleStormId(this.hurricaneIdData[idItem], null, null, true);
        if (this.hurricaneIdData[idItem].ToggledOn && !clear)
          this.toggleStormId(this.hurricaneIdData[idItem]);
      }
    },
    setStormTrackData(storm, stormTrackData) {
      stormTrackData.features.forEach(feature => {
        // eslint-disable-next-line
        var model = feature.properties.ParentModel ? feature.properties.ParentModel : feature.properties.Model;
        var subModel = feature.properties.Model;

        if (!storm.TrackData[model])
          storm.TrackData[model] = {
            Name: model,
            Models: {}
          };
        if (!storm.TrackData[model].Models[subModel])
          storm.TrackData[model].Models[subModel] = {
            Name: subModel,
            Lines: [],
            Points: []
          };
        if (feature.id === "Alternate Storm Path") {
          if (!storm.TrackData[model].Color)
            storm.TrackData[model].Color = feature.properties.stroke;
          storm.TrackData[model].Models[subModel].Lines.push(feature);
        } else if (feature.id === "Alternate Storm Position") {
          feature.id = "Storm Position";
          storm.TrackData[model].Models[subModel].Points.push(feature);
        }
      });
      for (var model in storm.TrackData) {
        for (var subModel in storm.TrackData[model].Models) {
          // eslint-disable-next-line
          storm.TrackData[model].Models[subModel].PointsGeoJson =  this.getFeatureGeoJson({
            type: "FeatureCollection",
            features: storm.TrackData[model].Models[subModel].Points,
            properties: {}
          });
          // eslint-disable-next-line
          storm.TrackData[model].Models[subModel].LinesGeoJson =  this.getFeatureGeoJson({
            type: "FeatureCollection",
            features: storm.TrackData[model].Models[subModel].Lines,
            properties: {}
          });
        }
      }
    },
    setStormFileData(storm, stormFileData) {
      const objectBase = {
        "Wind TOA/TOD": "NhcNcep34KtsTimeType",
        "Probabilistic Wind Speed": "WindSpeedKnots"
      };
      stormFileData.features.forEach(feature => {
        var isObjectId = false;
        if (objectBase[feature.id])
          if (feature.properties.hasOwnProperty(objectBase[feature.id]))
            isObjectId = true;

        if (!storm.FileData[feature.id]) {
          if (isObjectId) {
            storm.FileData[feature.id] = {};
            storm.GeoJsonLayers[feature.id] = {};
            storm.TempGeoJson[feature.id] = {};
          } else {
            storm.FileData[feature.id] = [];
            storm.GeoJsonLayers[feature.id] = [];
          }
        }
        if (isObjectId) {
          // eslint-disable-next-line
          if (!storm.FileData[feature.id][feature.properties[objectBase[feature.id]]]) {
            // eslint-disable-next-line
            storm.FileData[feature.id][feature.properties[objectBase[feature.id]]] = [];
            // eslint-disable-next-line
            storm.GeoJsonLayers[feature.id][feature.properties[objectBase[feature.id]]] = [];
            // eslint-disable-next-line
            storm.TempGeoJson[feature.id][feature.properties[objectBase[feature.id]]] = {};
          }
          feature.properties.label =
            feature.properties[objectBase[feature.id]] + "";
          // eslint-disable-next-line
          storm.FileData[feature.id][feature.properties[objectBase[feature.id]]].push(feature)  
          if (feature.id === "Probabilistic Wind Speed") {
            // eslint-disable-next-line
            if (!storm.TempGeoJson[feature.id][feature.properties[objectBase[feature.id]]][feature.properties.ForecastStartDateTimeUtc + "_" + feature.properties.ForecastEndDateTimeUtc])
              // eslint-disable-next-line
              storm.TempGeoJson[feature.id][feature.properties[objectBase[feature.id]]][feature.properties.ForecastStartDateTimeUtc + "_" + feature.properties.ForecastEndDateTimeUtc] = []
            // eslint-disable-next-line
            storm.TempGeoJson[feature.id][feature.properties[objectBase[feature.id]]][feature.properties.ForecastStartDateTimeUtc + "_" + feature.properties.ForecastEndDateTimeUtc].push(feature)
          } else
            // eslint-disable-next-line
            storm.GeoJsonLayers[feature.id][feature.properties[objectBase[feature.id]]].push(this.getFeatureGeoJson(feature))
        } else {
          storm.FileData[feature.id].push(feature);
          storm.GeoJsonLayers[feature.id].push(this.getFeatureGeoJson(feature));
        }
      });
      if (storm.TempGeoJson["Probabilistic Wind Speed"]) {
        for (let subKey in storm.TempGeoJson["Probabilistic Wind Speed"]) {
          // eslint-disable-next-line
          for (var time in storm.TempGeoJson["Probabilistic Wind Speed"][subKey]) {
            storm.GeoJsonLayers["Probabilistic Wind Speed"][subKey].push(
              this.getFeatureGeoJson(
                storm.TempGeoJson["Probabilistic Wind Speed"][subKey][time]
              )
            );
          }
          // eslint-disable-next-line
          storm.SliderData["Probabilistic Wind Speed_" + subKey] = this.getProbabilisticWindSliderData(storm.TempGeoJson["Probabilistic Wind Speed"][subKey])
        }
      }
      if (storm.FileData["Probabilistic Wind Speed"]) {
        for (let key in storm.FileData["Probabilistic Wind Speed"]) {
          storm.FileData["Probabilistic Wind Speed"][key].forEach(x => {
            // eslint-disable-next-line
            x.properties.Probability = `${x.properties.MinProbability}%-${x.properties.MaxProbability}%`
          });
        }
      }
      if (storm.FileData["Storm Position"]) {
        storm.GeoJsonLayers["Storm Position"] = [
          this.getFeatureGeoJson({
            type: "FeatureCollection",
            features: storm.FileData["Storm Position"],
            properties: {}
          })
        ];
        storm.FileData["Storm Position"].forEach(x => {
          storm.ZoomBounds.push([
            x.geometry.coordinates[1],
            x.geometry.coordinates[0]
          ]);
        });
      }
      storm.Legends = {};
      for (let key in this.hurricaneIdData) {
        if (this.hurricaneIdData[key].LegendKey) {
          if (Array.isArray(storm.FileData[key]))
            storm.Legends[key] = this.createLegend(
              this.hurricaneIdData[key].LegendKey,
              storm.FileData[key],
              this.hurricaneIdData[key].LegendKeySuffix
            );
          else {
            for (let subKey in storm.FileData[key])
              storm.Legends[key] = this.createLegend(
                this.hurricaneIdData[key].LegendKey,
                storm.FileData[key][subKey],
                this.hurricaneIdData[key].LegendKeySuffix,
                storm.Legends[key]
              );
          }
        }
      }
      storm.TempGeoJson = null;
      this.selectedStorm = storm;
      this.drawStoreDefaultLayers();
      this.zoomToBounds(storm.ZoomBounds);
    },
    getTrackLabelIcon(modelName) {
      var showValue = this.isShowingStormTracks(modelName);
      if (showValue === 1) return "check_box";
      else if (showValue === 0) return "indeterminate_check_box";
      else return "check_box_outline_blank";
    },
    toggleStormTracks(state, modelName) {
      var models = {};
      if (modelName) models[modelName] = modelName;
      else models = this.selectedStorm.TrackData;

      for (var model in models) {
        for (var subModel in this.selectedStorm.TrackData[model].Models) {
          if (state === true) {
            // eslint-disable
            if (!this.map.hasLayer(this.selectedStorm.TrackData[model].Models[subModel].LinesGeoJson))
              this.selectedStorm.TrackData[model].Models[subModel].LinesGeoJson.addTo(this.map);
            if (!this.map.hasLayer(this.selectedStorm.TrackData[model].Models[subModel].PointsGeoJson) && this.showTrackPoints)
              this.selectedStorm.TrackData[model].Models[subModel].PointsGeoJson.addTo(this.map);
          } else {
            if (this.map.hasLayer(this.selectedStorm.TrackData[model].Models[subModel].LinesGeoJson))
              this.map.removeLayer(this.selectedStorm.TrackData[model].Models[subModel].LinesGeoJson);
            if (this.map.hasLayer(this.selectedStorm.TrackData[model].Models[subModel].PointsGeoJson))
              this.map.removeLayer(this.selectedStorm.TrackData[model].Models[subModel].PointsGeoJson);
            // eslint-enable
          }
        }
      }
      this.$forceUpdate();
    },
    toggleStormTrackAll(modelName) {
      this.toggleStormTracks(
        this.isShowingStormTracks(modelName) < 1,
        modelName
      );
    },
    isShowingStormTracks(modelName) {
      var hasSingleLayer = false;
      var hasAllLayers = true;
      var models = {};
      if (modelName) models[modelName] = modelName;
      else models = this.selectedStorm.TrackData;

      for (var model in models) {
        for (var subModel in this.selectedStorm.TrackData[model].Models) {
          // eslint-disable-next-line
          if (this.map.hasLayer(this.selectedStorm.TrackData[model].Models[subModel].LinesGeoJson))
            hasSingleLayer = true;
          else hasAllLayers = false;
        }
      }
      if (hasAllLayers) return 1;
      else if (hasSingleLayer) return 0;
      else return -1;
    },
    toggleStormTrackLayer(subModel) {
      if (this.map.hasLayer(subModel.LinesGeoJson))
        this.map.removeLayer(subModel.LinesGeoJson);
      else subModel.LinesGeoJson.addTo(this.map);

      if (this.map.hasLayer(subModel.PointsGeoJson))
        this.map.removeLayer(subModel.PointsGeoJson);

      if (this.showTrackPoints && this.map.hasLayer(subModel.LinesGeoJson))
        subModel.PointsGeoJson.addTo(this.map);

      this.$forceUpdate();
    },
    getProbabilisticWindSliderData(data) {
      var timeStart;
      var timeEnd;
      var tickData = {};
      var maxOffset = 0;
      var lowOffset = 99999999;

      for (let range in data) {
        let times = range.split("_");
        if (!timeStart) timeStart = moment(times[0]);
        if (!timeEnd) timeEnd = moment(times[1]);
        if (moment(timeStart).isAfter(moment(times[0])))
          timeStart = moment(times[0]);
        if (moment(timeEnd).isBefore(moment(times[1])))
          timeEnd = moment(times[1]);
      }

      for (let range in data) {
        let times = range.split("_");
        var offset = moment
          .duration(moment(times[1]).diff(timeStart))
          .asHours();
        var duration = moment
          .duration(moment(times[1]).diff(times[0]))
          .asHours();
        if (offset > maxOffset) maxOffset = offset;
        if (offset < lowOffset) lowOffset = offset;
        tickData[offset] = {
          OffsetEnd: offset,
          OffsetStart: moment
            .duration(moment(times[0]).diff(timeStart))
            .asHours(),
          Duration: duration,
          TimeStart: moment(times[0]),
          TimeEnd: moment(times[1])
        };
      }

      return {
        MaxOffset: maxOffset,
        TickData: tickData,
        GetTicks: () => {
          var ticks = [];
          for (var t in tickData) ticks.push(t);
          return ticks;
        },
        SliderNum: lowOffset,
        DayData: () => {
          return this.getCurrentOverlayDaySpacerData(timeStart, maxOffset);
        }
      };
    },
    playNextStormSliderFrame(direction, idItem, subCategoryId, useRepeat) {
      if (!idItem) return;
      if (!this.selectedStorm.SliderData[idItem.Label + "_" + subCategoryId])
        return;
      var currentIdx = this.getStormSliderIdx(idItem.Label, subCategoryId);
      // eslint-disable-next-line
      var ticks = this.selectedStorm.SliderData[idItem.Label +'_'+ subCategoryId].GetTicks();
      var maxIdx = ticks.length - 1;
      if (useRepeat) if (!this.overlayRepeat && currentIdx === maxIdx) return;
      var newIdx = currentIdx + direction;
      if (newIdx < 0) newIdx = maxIdx;
      else if (newIdx > maxIdx) newIdx = 0;
      // eslint-disable-next-line
      this.selectedStorm.SliderData[idItem.Label +'_'+ subCategoryId].SliderNum = ticks[newIdx]
      this.toggleStormSlider(newIdx, idItem, subCategoryId);
    },
    getWindToaTodGeoJsonMouseEvents(geoJson, feature) {
      var self = this;
      var popUpFunction = function(c) {
        c.layer.setStyle({
          fillOpacity: 0.3,
          fillColor: "#000"
        });
        // eslint-disable-next-line
        L.popup({ closeButton: false, className: "position-popup" })
          .setLatLng(c.latlng)
          // eslint-disable-next-line
          .setContent(`<div style="text-align: center;">${self.formatTime(feature.properties.MinDate)} - ${self.formatTime(feature.properties.MaxDate)}</div>`)
          .openOn(self.map);
      };
      var closeFunction = function(c) {
        self.map.closePopup();
        c.layer.setStyle({
          fillOpacity: feature.properties["fill-opacity"],
          fillColor: feature.properties["fill"]
        });
      };
      geoJson
        .on("mouseover", popUpFunction)
        .on("click", popUpFunction)
        .on("mouseout", closeFunction)
        .on("dblclick", closeFunction);
      return geoJson;
    },
    getFeatureGeoJson(feature) {
      var self = this;
      var options = {
        style: function(f) {
          var styles = {
            weight: f.properties["stroke-width"],
            fillOpacity: f.properties["fill-opacity"],
            strokeOpacity: f.properties["stroke-opacity"],
            fillRule: "nonzero",
            color: f.properties["stroke"],
            fillColor: f.properties["fill"]
          };
          return styles;
        },
        pointToLayer: function(feature, latlng) {
          var html =
            `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" style="transform: translate(-7px, -17px);">` +
            // eslint-disable-next-line
            `<path fill="${feature.properties['marker-color']}" d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7z"/>`;

          if (feature.properties["marker-symbol"] === "circle")
            html += `<circle cx="12" fill="#fff" stroke="#fff" cy="9" r="3"/>`;
          else if (feature.properties["marker-symbol"] === "circle-stroked")
            // eslint-disable-next-line
            html += `<circle cx="12" cy="9" r="4" stroke="#fff" fill="${feature.properties['marker-color']}"/>`;
          else if (feature.properties["marker-symbol"] === "cross")
            html += `<path style="transform: scale(.6) translate(8px, 4px);" fill="#fff" d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"/>`;

          html += `</svg>`;
          // eslint-disable-next-line
          var icon = new L.DivIcon({
            html: html,
            className: "",
            // eslint-disable-next-line
            iconSize: new L.Point(10, 10)
          });
          // eslint-disable-next-line
          var marker = L.marker(latlng, { icon: icon });
          var popUpFunction = function(c) {
            var titles = "";
            var info = "";
            // eslint-disable-next-line
            for (var attr in self.hurricaneIdData[feature.id].PopupAttributes) {
              if (feature.properties[attr]) {
                titles += `<div class="position-popup-title">${attr}</div>`;
                // eslint-disable-next-line
                if(self.hurricaneIdData[feature.id].PopupAttributes[attr] === "date")
                  // eslint-disable-next-line
                  info += `<div class="position-popup-info">${self.formatTime(feature.properties[attr])}</div>`;
                else
                  // eslint-disable-next-line
                  info += `<div class="position-popup-info">${feature.properties[attr]}</div>`;
              }
            }
            var html = `<div><div style="float: left;">${titles}</div>`;
            html += `<div>${info}</div></div>`;
            // eslint-disable-next-line
            L.popup({ closeButton: false, className: 'position-popup' })
              .setLatLng(c.latlng)
              .setContent(html)
              .openOn(self.map);
          };
          var closeFunction = function(c) {
            self.map.closePopup();
          };
          marker
            .on("mouseover", popUpFunction)
            .on("click", popUpFunction)
            .on("mouseout", closeFunction)
            .on("dblclick", closeFunction);
          return marker;
        }
      };
      // eslint-disable-next-line
      var geoJson = L.geoJson(feature, options);
      if (feature.id === "Wind TOA/TOD")
        this.getWindToaTodGeoJsonMouseEvents(geoJson, feature);
      return geoJson;
    },
    toggleStormSlider(event, idItem, subCategoryId) {
      var scrubIdx = this.getStormSliderIdx(idItem.Label, subCategoryId);
      if (scrubIdx > -1) this.toggleStormId(idItem, subCategoryId, scrubIdx);
    },
    getStormSliderIdx(categoryId, subCategoryId, offset) {
      if (this.selectedStorm.SliderData[categoryId + "_" + subCategoryId]) {
        if (!offset)
          // eslint-disable-next-line
          offset = this.selectedStorm.SliderData[categoryId +'_'+ subCategoryId].SliderNum;
        return this.selectedStorm.SliderData[categoryId + "_" + subCategoryId]
          .GetTicks()
          .indexOf(`${offset}`);
      }
      return null;
    },
    hurricaneIdDataButtonGroupOn() {
      var on = [];
      this.hurricaneIdDataButtonGroup.forEach(x => {
        if (x.ToggleBtn) on.push(x.Label);
      });
      return on;
    },
    toggleStormSubId(idItem, subCategoryId, idx) {
      if (!idx) idx = 0;
      if (idItem.UseScrub) {
        this.stopOverlay();
        if (this.stormIdHasLayer(idItem, subCategoryId, idx)) {
          this.selectedStorm.ScrubId = null;
          this.selectedStorm.SubScrubId = null;
        } else {
          this.selectedStorm.ScrubIdItem = idItem;
          this.selectedStorm.SubScrubId = subCategoryId;
        }
      }
      this.toggleStormId(
        idItem,
        subCategoryId,
        idx,
        this.stormIdHasLayer(idItem, subCategoryId, idx)
      );
    },
    stormIdHasLayer(idItem, subCategoryId, idx) {
      if (idx == null) idx = 0;
      if (this.selectedStorm.GeoJsonLayers[idItem.Label]) {
        if (subCategoryId)
          if (this.selectedStorm.GeoJsonLayers[idItem.Label][subCategoryId])
            return this.map.hasLayer(
              this.selectedStorm.GeoJsonLayers[idItem.Label][subCategoryId][idx]
            );
        return this.map.hasLayer(
          this.selectedStorm.GeoJsonLayers[idItem.Label][idx]
        );
      }
      return false;
    },
    createLegend(legendKey, data, legendValueSuffix, legend) {
      if (!legend) legend = {};
      if (!legendValueSuffix) legendValueSuffix = "";
      data.forEach(x => {
        if (!legend[x.properties[legendKey]])
          legend[x.properties[legendKey]] = {
            Value: x.properties[legendKey] + legendValueSuffix,
            Fill: x.properties.fill,
            FillOpacity: x.properties["fill-opacity"],
            Border: x.properties.stroke
          };
      });
      return legend;
    },
    toggleStormId(idItem, subCategoryId, scrubIdx, clear) {
      if (this.selectedStorm.GeoJsonLayers) {
        if (this.selectedStorm.GeoJsonLayers[idItem.Label]) {
          if (idItem.Category === "subCategories") {
            for (var key in this.selectedStorm.GeoJsonLayers[idItem.Label])
              this.selectedStorm.GeoJsonLayers[idItem.Label][key].forEach(x => {
                if (this.map.hasLayer(x)) this.map.removeLayer(x);
              });
            if (this.selectedStorm.GeoJsonLayers[idItem.Label][subCategoryId]) {
              if (!idItem.UseScrub) {
                if (
                  idItem.ToggledOn &&
                  !clear &&
                  this.selectedStorm.GeoJsonLayers[idItem.Label][subCategoryId]
                ) {
                  // eslint-disable-next-line
                  this.selectedStorm.GeoJsonLayers[idItem.Label][subCategoryId].forEach(x => {
                    x.addTo(this.map);
                  });
                }
              } else if (
                scrubIdx > -1 &&
                !clear &&
                // eslint-disable-next-line
                this.selectedStorm.GeoJsonLayers[idItem.Label][subCategoryId].length > scrubIdx
              ) {
                // eslint-disable-next-line
                this.selectedStorm.GeoJsonLayers[idItem.Label][subCategoryId][scrubIdx].addTo(this.map);
              }
            }
          } else {
            if (idItem.Category === "singleArray") {
              if (idItem.ToggledOn && !clear) {
                this.selectedStorm.GeoJsonLayers[idItem.Label][0].addTo(
                  this.map
                );
              } else {
                if (
                  this.map.hasLayer(
                    this.selectedStorm.GeoJsonLayers[idItem.Label][0]
                  )
                ) {
                  this.map.removeLayer(
                    this.selectedStorm.GeoJsonLayers[idItem.Label][0]
                  );
                }
              }
            } else if (idItem.Category === "array") {
              if (idItem.ToggledOn && !clear) {
                this.selectedStorm.GeoJsonLayers[idItem.Label].forEach(x => {
                  x.addTo(this.map);
                });
              } else {
                this.selectedStorm.GeoJsonLayers[idItem.Label].forEach(x => {
                  if (this.map.hasLayer(x)) {
                    this.map.removeLayer(x);
                  }
                });
              }
            }
          }
        }
      }
      this.$forceUpdate();
    }
  },
  data() {
    return {
      hurricaneOverviewLayer: null,
      showWeatherOverlaySelect: false,
      showHurricaneOverlaySelect: false,
      showTrackPoints: false,
      hurricaneTreeData: [],
      selectedStorm: null,
      hurricaneIdData: {
        "Forecast Cone": {
          Label: "Forecast Cone",
          Category: "singleArray",
          UseScrub: false,
          ToggledOn: true,
          ToggledOnInit: true,
          ToggleBtn: true
        },
        "Storm Path": {
          Label: "Storm Path",
          Category: "singleArray",
          UseScrub: true,
          ToggledOn: true,
          ToggledOnInit: true,
          ToggleBtn: true
        },
        "Storm Position": {
          Label: "Storm Position",
          Category: "singleArray",
          UseScrub: true,
          ToggledOn: true,
          ToggledOnInit: true,
          ToggleBtn: true,
          PopupAttributes: {
            ForecastDateTimeUtc: "date",
            PressureMillibars: "string",
            StormType: "string",
            WindSpeedMph: "string",
            SaffirSimpsonCategory: "string",
            HurricaneCategory: "string",
            StormName: "string"
          }
        },
        "Future Storm Wind Boundary": {
          Label: "Future Storm Wind Boundary",
          Category: "singleArray",
          UseScrub: false,
          ToggleBtn: true
        },
        "Historic Wind Swath": {
          Label: "Historic Wind Swath",
          Category: "array",
          UseScrub: true,
          ToggleBtn: true,
          LegendKey: "WindSpeedKnots",
          LegendKeySuffix: "kts"
        },
        "Wind TOA/TOD": {
          Label: "Wind TOA/TOD",
          Category: "subCategories",
          MultiSelect: false,
          UseScrub: false,
          ToggledCategoryId: null,
          ToggledOn: true,
          IsLabel: true
        },
        "Probabilistic Wind Speed": {
          Label: "Probabilistic Wind Speed",
          Category: "subCategories",
          MultiSelect: false,
          UseScrub: true,
          ToggledCategoryId: null,
          LegendKey: "Probability",
          ToggledOn: true,
          IsLabel: true
        }
      },
      alertDayData: {},
      alertDaySelectData: [],
      alertSummaryHeaders: [
        {
          text: "Risk",
          value: "alertid",
          align: "left"
        },
        {
          text: "Alert Type",
          value: "type",
          align: "left"
        },
        {
          text: "Effective Date",
          value: "effectivedate",
          align: "left"
        },
        {
          text: "Expiration Date",
          value: "expiresdate",
          align: "left"
        },
        {
          text: "Summary",
          value: "summary",
          align: "left"
        }
      ],
      alertsTableSearch: "",
      alertTypeKeysToDesc: {},
      currentOverlay: null,
      currentTab: 0,
      currentTileLayer: null,
      deliverabilityAlertTypesToggle: {},
      drawnPolygons: null,
      filteredTotalSummary: {},
      geoJsonLayer: null,
      gridTabs: [
        {
          key: "alertsTab",
          label: "Alerts"
        },
        {
          key: "weatherTab",
          label: "Weather"
        },
        {
          key: "hurricaneTab",
          label: "Hurricanes"
        }
      ],
      hoveredMarkerItem: null,
      map: {},
      overlayNavWidth: 275,
      overlayPlaySpeedIdx: 1,
      overlayPlaySpeeds: [
        {
          duration: 250,
          label: ".25s"
        },
        {
          duration: 500,
          label: ".5s"
        },
        {
          duration: 1000,
          label: "1s"
        },
        {
          duration: 2000,
          label: "2s"
        }
      ],
      overlayRepeat: true,
      overlayTimeout: null,
      overlayTreeData: [],
      descending: true,
      sortBy: "normalizedrisk",
      play: false,
      refreshing: false,
      regions: {
        Alaska: {
          getBounds: () => [[48.492947, -181.118003], [71.204575, -129.205226]]
        },
        ContiguousUnitedStates: {
          getBounds: () => [
            [24.7433195, -124.7844079],
            [49.3457868, -66.9513812]
          ]
        },
        Hawaii: {
          getBounds: () => [[18.461862, -161.328558], [22.761936, -154.41187]]
        },
        PuertoRico: {
          getBounds: () => [[16.954542, -68.122906], [19.571666, -63.965776]]
        },
        Complete: {
          getBounds: () => [[17.66128, -181.118003], [71.204575, -64.489442]]
        }
      },
      resumePlay: false,
      riskCategoriesToggle: {
        Extreme: {
          toggle: true,
          label: "Extreme",
          fill: "#ffaaad",
          stroke: "#E6080E",
          backgroundColor: "#f7bab7"
        },
        High: {
          toggle: true,
          label: "High",
          fill: "#fac682",
          stroke: "#ff8f00",
          backgroundColor: "#ffdcaf"
        },
        Medium: {
          toggle: true,
          label: "Medium",
          fill: "#ffff00",
          stroke: "#b8b832",
          backgroundColor: "#f9f8be"
        },
        Low: {
          toggle: false,
          label: "Low",
          fill: "#87ec87",
          stroke: "#189518",
          backgroundColor: "#c2edbf"
        }
      },
      selectedAlertMarker: null,
      selectedDay: "",
      selectedOverlay: {},
      selectedTimezone: "Etc/UTC",
      showCollectionFileId: "",
      showGrid: true,
      showOverlaySelect: false,
      showMap: true,
      sliderNum: 0,
      tileLayer: null,
      timeZones: [
        {
          Label: "UTC",
          Code: "Etc/UTC"
        },
        {
          Label: "Eastern",
          Code: "EST5EDT"
        },
        {
          Label: "Central",
          Code: "CST6CDT"
        },
        {
          Label: "Mountain",
          Code: "MST7MDT"
        },
        {
          Label: "Pacific",
          Code: "PST8PDT"
        },
        {
          Label: "Hawaii",
          Code: "Pacific/Honolulu"
        },
        {
          Label: "Guam",
          Code: "Pacific/Guam"
        }
      ]
    };
  },
  watch: {
    currentTab: function(val) {
      this.stopOverlay();
      if (
        (val === 1 && !this.currentOverlay) ||
        (val === 2 && !this.selectedStorm)
      )
        this.showOverlaySelect = true;
      if (this.showOverlaySelect) {
        if (val === 1) {
          this.showHurricaneOverlaySelect = false;
          this.showWeatherOverlaySelect = true;
        } else if (val === 2) {
          this.showWeatherOverlaySelect = false;
          this.showHurricaneOverlaySelect = true;
        }
      }
    },
    showTrackPoints: function(val) {
      if (this.selectedStorm) {
        for (var model in this.selectedStorm.TrackData) {
          for (var subModel in this.selectedStorm.TrackData[model].Models) {
            // eslint-disable-next-line
            if (this.map.hasLayer(this.selectedStorm.TrackData[model].Models[subModel].LinesGeoJson)) {
              if (val)
                // eslint-disable-next-line
                this.selectedStorm.TrackData[model].Models[subModel].PointsGeoJson.addTo(this.map);
              else
                this.map.removeLayer(
                  this.selectedStorm.TrackData[model].Models[subModel]
                    .PointsGeoJson
                );
            }
          }
        }
      }
    },
    deliverabilityAlertTypesToggle: {
      handler: function(val, oldVal) {
        this.hoveredMarkerItem = null;
        if (this.selectedDay)
          this.createDayGeoJson(this.alertDayData[this.selectedDay].Data);
        this.setFilteredTotalSummary();
        this.$forceUpdate();
      },
      deep: true
    },
    riskCategoriesToggle: {
      handler: function(val, oldVal) {
        this.hoveredMarkerItem = null;
        if (this.selectedDay)
          this.createDayGeoJson(this.alertDayData[this.selectedDay].Data);
        this.setFilteredTotalSummary();
        this.$forceUpdate();
      },
      deep: true
    },
    selectedDay: function(val) {
      this.createDayGeoJson(this.alertDayData[val].Data);
      setTimeout(() => {
        this.zoomToFit(this.regions.ContiguousUnitedStates);
      }, 500);
      this.hoveredMarkerItem = null;
      this.$forceUpdate();
    }
  },
  mounted: function() {
    this.initDeliverabilityAlertsMap();
    this.initTimeZones();
    $("head").append(
      '<style id="overlay-layer-styles" type="text/css"></style>'
    );
  },
  created: function() {
    this.$registerVuexModule(
      DELIVERABILITY_ALERTS_MAP_NAMESPACE,
      deliverabilityAlertsMapModule
    );
    this.$isInRole([this.$roleDefs.ADMIN, this.$roleDefs.BETA_FEATURE]).then(
      res => {
        if (res) {
          this.loadAlertTypes();
          this.loadMapData();
          this.loadMapOverlayFiles();
          this.loadHurricaneStormList();

          window.addEventListener("keydown", e => {
            if (e.key === "ArrowLeft" || e.key === "a") {
              if (this.play) this.stopOverlay();
              if (this.currentOverlay && this.currentTab === 1) {
                this.clearLayers();
                this.playNextOverlayFrame(-1);
              } else if (this.selectedStorm && this.currentTab === 2)
                this.playNextStormSliderFrame(
                  -1,
                  this.selectedStorm.ScrubIdItem,
                  this.selectedStorm.SubScrubId
                );
            } else if (e.key === "ArrowRight" || e.key === "d") {
              if (this.play) this.stopOverlay();
              if (this.currentOverlay && this.currentTab === 1) {
                this.clearLayers();
                this.playNextOverlayFrame(1);
              } else if (this.selectedStorm && this.currentTab === 2)
                if (this.selectedStorm.ScrubIdItem)
                  this.playNextStormSliderFrame(
                    1,
                    this.selectedStorm.ScrubIdItem,
                    this.selectedStorm.SubScrubId
                  );
            } else if (e.key === "ArrowUp" || e.key === "w") {
              var idx = this.overlayPlaySpeedIdx - 1;
              if (idx < 0) idx = this.overlayPlaySpeeds.length - 1;
              this.overlayPlaySpeedIdx = idx;
            } else if (e.key === "ArrowDown" || e.key === "s") {
              this.overlayPlaySpeedIdx =
                (this.overlayPlaySpeedIdx + 1) % this.overlayPlaySpeeds.length;
            } else if (e.code === "Space") {
              if (this.play) {
                this.stopOverlay();
              } else {
                if (this.currentOverlay && this.currentTab === 1)
                  this.playSelectedOverlay(this.sliderNum);
                else if (this.selectedStorm && this.currentTab === 2)
                  this.playSelectedStormOverlay(
                    this.selectedStorm.ScrubIdItem,
                    this.selectedStorm.SubScrubId
                  );
              }
            }
          });
        } else this.$goHome();
      }
    );
  }
};
</script>


<style>
.deliverability-map .vue-slider-mark:first-child .vue-slider-mark-step, .vue-slider-mark:last-child .vue-slider-mark-step {
  display: block;
}
.deliverability-map .vue-slider-dot-tooltip-inner {
  padding: 0;
}
.deliverability-map .vue-slider-dot-tooltip-top {
  top: -5px;
}
.slider-day-ticks{
  position: absolute;
}
.deliverability-map .vue-slider-mark-step{
  background-color: #787878;
}
.deliverability-map .vue-slider-dot-tooltip-inner{
  border-color: #787878;
    background-color: #787878;
}
.slider-day-tick{
  width: 2px;
  height: 10px;
  background-color: #787878;
  position: relative;
  bottom: 11px;
  right: 1px;
}
.slider-day-label{
  position: relative;
  bottom: 11px;
  right: 50%;
  font-size: 10px;
  font-weight: 900;
}
.deliverability-map .select-box .v-label{
  color: black !important;
  white-space: nowrap;
}
.select-checkbox-cover-deliverability{
  width: 100%;
  height: 100%;
  position: absolute;
  right: 0;
}

.deliverability-map .alert_selectors .v-select__selections div{
  position: absolute;
}
.deliverability-map .day_selectors .v-select__selections input{
  position: absolute;
}

.overlay-legend-table .v-input--selection-controls .v-input__slot {
  margin-bottom: 0;
}

.deliverability-map .leaflet-popup-content {
  margin: 10px !important;
  line-height: 1.4 !important;
  min-width: 180px;
}

.hover-summary{
  background-color: whitesmoke;
  position: absolute;
  right: 0px;
  top: 0px;
  border: 1px solid #d5d5d5;
  padding: 10px;
  max-width: 500px;
}

.overlay-legend-table thead{
  display: none;
}
.deliverability-map .btn-hover:hover{
  background-color: #e5e1e1;
  border-radius: 50%;
}
.overlay-list-item:hover{
  background-color: #e5e1e1;
}
.overlay-legend-row:hover{
  background-color: #eeeeee;
}

.overlay-legend-row{
  background-color: #FFF;
}
.overlay-legend-table{
  box-shadow: 0px 2px 1px -1px rgba(0, 0, 0, 0.2), 0px 1px 1px 0px rgba(0, 0, 0, 0.14), 0px 1px 3px 0px rgba(0, 0, 0, 0.12) !important;
}
.overlay-legend-table .overlay-legend-row:not(:last-child) {
  border-bottom: 1px solid rgba(0, 0, 0, 0.12);
}

.deliverability-map .slider-event-duration{
  position: absolute;
  width: 100%;
  top: 0;
  left: 0;
}

.deliverability-map .event-duration{
  position: absolute;
  height: 4px;
  background-color: red;
  top: 7px;
  z-index: 1;
}

.deliverability-map .vue-slider-dot-tooltip-text{
  padding: 0 2px;
}

</style>
